export default [
  {
    id: 726,
    skuId: 'J11872',
    title: 'COCO CRUSH戒指',
    plpTitle: '["COCO CRUSH", "戒指"]',
    pdpTitle: '["COCO CRUSH", "戒指"]',
    description: '菱格纹图案，精致款，黄18K金，镶嵌钻石',
    plpDescription: '菱格纹图案，精致款\n黄18K金，镶嵌钻石',
    pdpDescription: '菱格纹图案，精致款，黄18K金，镶嵌钻石',
    price: 34100.0,
    localPrice: 0.0,
    isShow: '1',
    isPutOn: '1',
    plpTitleLine: 2,
    plpTitleType: 1,
    plpDescriptionLine: 2,
    pdpImgCount: 4,
    shareTitle: '虚拟试戴COCO CRUSH戒指',
    vtoType: 'RING',
    extJson:
      '{"navigationbackpath":"/activities/2025/cococrush/pages/index/index?scene=plp"}',
    view3d: 1,
    createTimestamp: 1734426960311,
    isDeleted: false,
    updateTimestamp: 1734541305826
  },
  {
    id: 727,
    skuId: 'J12305',
    title: 'Coco Crush项链',
    plpTitle: '["COCO CRUSH", "项链"]',
    pdpTitle: '["COCO CRUSH", "项链"]',
    description: '菱格纹图案，黄18K金',
    plpDescription: '菱格纹图案，黄18K金',
    pdpDescription: '菱格纹图案，黄18K金',
    price: 21100.0,
    localPrice: 0.0,
    isShow: '1',
    isPutOn: '0',
    plpTitleLine: 2,
    plpTitleType: 1,
    plpDescriptionLine: 1,
    pdpImgCount: 4,
    shareTitle: 'COCO CRUSH项链',
    vtoType: '',
    extJson:
      '{"navigationbackpath":"/activities/2025/cococrush/pages/index/index?scene=plp"}',
    view3d: 1,
    createTimestamp: 1734426950156,
    isDeleted: false,
    updateTimestamp: 1734541305467
  },
  {
    id: 728,
    skuId: 'J13330',
    title: 'COCO CRUSH单只耳环',
    plpTitle: '["COCO CRUSH", "单只耳环"]',
    pdpTitle: '["COCO CRUSH", "单只耳环"]',
    description: '菱格纹图案，黄18K金，镶嵌钻石',
    plpDescription: '菱格纹图案，黄18K金\n镶嵌钻石',
    pdpDescription: '菱格纹图案，黄18K金，镶嵌钻石',
    price: 21100.0,
    localPrice: 0.0,
    isShow: '1',
    isPutOn: '0',
    plpTitleLine: 2,
    plpTitleType: 1,
    plpDescriptionLine: 2,
    pdpImgCount: 1,
    shareTitle: '虚拟试戴COCO CRUSH单只耳环',
    vtoType: '',
    extJson:
      '{"navigationbackpath":"/activities/2025/cococrush/pages/index/index?scene=plp"}',
    view3d: 0,
    createTimestamp: 1733476242672,
    isDeleted: false,
    updateTimestamp: 1736228538802
  },
  {
    id: 729,
    skuId: 'J13312',
    title: 'COCO单只耳环',
    plpTitle: '["COCO", "单只耳环"]',
    pdpTitle: '["COCO", "单只耳环"]',
    description: '菱格纹图案，白18K金，镶嵌钻石',
    plpDescription: '菱格纹图案，白18K金\n镶嵌钻石',
    pdpDescription: '菱格纹图案，白18K金，镶嵌钻石',
    price: 22200.0,
    localPrice: 0.0,
    isShow: '1',
    isPutOn: '1',
    plpTitleLine: 2,
    plpTitleType: 1,
    plpDescriptionLine: 2,
    pdpImgCount: 2,
    shareTitle: 'COCO单只耳环',
    vtoType: 'EARRINGS',
    extJson:
      '{"navigationbackpath":"/activities/2025/cococrush/pages/index/index?scene=plp"}',
    view3d: 0,
    createTimestamp: 1733476242377,
    isDeleted: false,
    updateTimestamp: 1736228539131
  },
  {
    id: 730,
    skuId: 'J13311',
    title: 'COCO单只耳环',
    plpTitle: '["COCO", "单只耳环"]',
    pdpTitle: '["COCO", "单只耳环"]',
    description: '菱格纹图案，米色18K金，镶嵌钻石',
    plpDescription: '菱格纹图案，米色18K金\n镶嵌钻石',
    pdpDescription: '菱格纹图案，米色18K金，镶嵌钻石',
    price: 21100.0,
    localPrice: 0.0,
    isShow: '1',
    isPutOn: '1',
    plpTitleLine: 2,
    plpTitleType: 1,
    plpDescriptionLine: 2,
    pdpImgCount: 1,
    shareTitle: 'COCO单只耳环',
    vtoType: 'EARRINGS',
    extJson:
      '{"navigationbackpath":"/activities/2025/cococrush/pages/index/index?scene=plp"}',
    view3d: 0,
    createTimestamp: 1733476242087,
    isDeleted: false,
    updateTimestamp: 1736228539388
  },
  {
    id: 731,
    skuId: 'J13310',
    title: 'COCO单只耳环',
    plpTitle: '["COCO", "单只耳环"]',
    pdpTitle: '["COCO", "单只耳环"]',
    description: '菱格纹图案，黄18K金，镶嵌钻石',
    plpDescription: '菱格纹图案，黄18K金\n镶嵌钻石',
    pdpDescription: '菱格纹图案，黄18K金，镶嵌钻石',
    price: 20800.0,
    localPrice: 0.0,
    isShow: '1',
    isPutOn: '1',
    plpTitleLine: 2,
    plpTitleType: 1,
    plpDescriptionLine: 2,
    pdpImgCount: 1,
    shareTitle: 'COCO单只耳环',
    vtoType: 'EARRINGS',
    extJson:
      '{"navigationbackpath":"/activities/2025/cococrush/pages/index/index?scene=plp"}',
    view3d: 0,
    createTimestamp: 1733476241767,
    isDeleted: false,
    updateTimestamp: 1736228539641
  },
  {
    id: 732,
    skuId: 'J13309',
    title: 'COCO单只耳环',
    plpTitle: '["COCO", "单只耳环"]',
    pdpTitle: '["COCO", "单只耳环"]',
    description: '菱格纹图案，白18K金，镶嵌钻石',
    plpDescription: '菱格纹图案，白18K金\n镶嵌钻石',
    pdpDescription: '菱格纹图案，白18K金，镶嵌钻石',
    price: 21800.0,
    localPrice: 0.0,
    isShow: '1',
    isPutOn: '1',
    plpTitleLine: 2,
    plpTitleType: 1,
    plpDescriptionLine: 2,
    pdpImgCount: 2,
    shareTitle: 'COCO单只耳环',
    vtoType: 'EARRINGS',
    extJson:
      '{"navigationbackpath":"/activities/2025/cococrush/pages/index/index?scene=plp"}',
    view3d: 0,
    createTimestamp: 1733476241456,
    isDeleted: false,
    updateTimestamp: 1736228539944
  },
  {
    id: 733,
    skuId: 'J13308',
    title: 'COCO单只耳环',
    plpTitle: '["COCO", "单只耳环"]',
    pdpTitle: '["COCO", "单只耳环"]',
    description: '菱格纹图案，米色18K金，镶嵌钻石',
    plpDescription: '菱格纹图案，米色18K金\n镶嵌钻石',
    pdpDescription: '菱格纹图案，米色18K金，镶嵌钻石',
    price: 20800.0,
    localPrice: 0.0,
    isShow: '1',
    isPutOn: '1',
    plpTitleLine: 2,
    plpTitleType: 1,
    plpDescriptionLine: 2,
    pdpImgCount: 3,
    shareTitle: 'COCO单只耳环',
    vtoType: 'EARRINGS',
    extJson:
      '{"navigationbackpath":"/activities/2025/cococrush/pages/index/index?scene=plp"}',
    view3d: 0,
    createTimestamp: 1733476241170,
    isDeleted: false,
    updateTimestamp: 1736228540203
  },
  {
    id: 734,
    skuId: 'J13307',
    title: 'COCO单只耳环',
    plpTitle: '["COCO", "单只耳环"]',
    pdpTitle: '["COCO", "单只耳环"]',
    description: '菱格纹图案，黄18K金，镶嵌钻石',
    plpDescription: '菱格纹图案，黄18K金\n镶嵌钻石',
    pdpDescription: '菱格纹图案，黄18K金，镶嵌钻石',
    price: 20300.0,
    localPrice: 0.0,
    isShow: '1',
    isPutOn: '1',
    plpTitleLine: 2,
    plpTitleType: 1,
    plpDescriptionLine: 2,
    pdpImgCount: 2,
    shareTitle: 'COCO单只耳环',
    vtoType: 'EARRINGS',
    extJson:
      '{"navigationbackpath":"/activities/2025/cococrush/pages/index/index?scene=plp"}',
    view3d: 0,
    createTimestamp: 1733476240889,
    isDeleted: false,
    updateTimestamp: 1736228540516
  },
  {
    id: 735,
    skuId: 'J13220',
    title: 'COCO CRUSH单只耳环',
    plpTitle: '["COCO CRUSH", "单只耳环"]',
    pdpTitle: '["COCO CRUSH", "单只耳环"]',
    description: '菱格纹图案，米色18K金，镶嵌钻石',
    plpDescription: '菱格纹图案，米色18K金\n镶嵌钻石',
    pdpDescription: '菱格纹图案，米色18K金，镶嵌钻石',
    price: 21500.0,
    localPrice: 0.0,
    isShow: '1',
    isPutOn: '0',
    plpTitleLine: 2,
    plpTitleType: 1,
    plpDescriptionLine: 2,
    pdpImgCount: 1,
    shareTitle: '虚拟试戴COCO CRUSH单只耳环',
    vtoType: '',
    extJson:
      '{"navigationbackpath":"/activities/2025/cococrush/pages/index/index?scene=plp"}',
    view3d: 0,
    createTimestamp: 1733476240619,
    isDeleted: false,
    updateTimestamp: 1736228540772
  },
  {
    id: 736,
    skuId: 'J13219',
    title: 'COCO CRUSH单只耳环',
    plpTitle: '["COCO CRUSH", "单只耳环"]',
    pdpTitle: '["COCO CRUSH", "单只耳环"]',
    description: '菱格纹图案，白18K金，镶嵌钻石',
    plpDescription: '菱格纹图案，白18K金\n镶嵌钻石',
    pdpDescription: '菱格纹图案，白18K金，镶嵌钻石',
    price: 22600.0,
    localPrice: 0.0,
    isShow: '1',
    isPutOn: '0',
    plpTitleLine: 2,
    plpTitleType: 1,
    plpDescriptionLine: 2,
    pdpImgCount: 1,
    shareTitle: '虚拟试戴COCO CRUSH单只耳环',
    vtoType: '',
    extJson:
      '{"navigationbackpath":"/activities/2025/cococrush/pages/index/index?scene=plp"}',
    view3d: 0,
    createTimestamp: 1733476240341,
    isDeleted: false,
    updateTimestamp: 1736228541033
  },
  {
    id: 737,
    skuId: 'J13217',
    title: 'COCO项链',
    plpTitle: '["COCO", "项链"]',
    pdpTitle: '["COCO", "项链"]',
    description: '菱格纹图案，米色18K金，镶嵌钻石',
    plpDescription: '菱格纹图案，米色18K金\n镶嵌钻石',
    pdpDescription: '菱格纹图案，米色18K金，镶嵌钻石',
    price: 80500.0,
    localPrice: 0.0,
    isShow: '1',
    isPutOn: '0',
    plpTitleLine: 2,
    plpTitleType: 1,
    plpDescriptionLine: 2,
    pdpImgCount: 4,
    shareTitle: 'COCO项链',
    vtoType: '',
    extJson:
      '{"navigationbackpath":"/activities/2025/cococrush/pages/index/index?scene=plp"}',
    view3d: 0,
    createTimestamp: 1733476240050,
    isDeleted: false,
    updateTimestamp: 1736228541305
  },
  {
    id: 738,
    skuId: 'J13216',
    title: 'COCO项链',
    plpTitle: '["COCO", "项链"]',
    pdpTitle: '["COCO", "项链"]',
    description: '菱格纹图案，白18K金，镶嵌钻石',
    plpDescription: '菱格纹图案，白18K金\n镶嵌钻石',
    pdpDescription: '菱格纹图案，白18K金，镶嵌钻石',
    price: 84500.0,
    localPrice: 0.0,
    isShow: '1',
    isPutOn: '0',
    plpTitleLine: 2,
    plpTitleType: 1,
    plpDescriptionLine: 1,
    pdpImgCount: 4,
    shareTitle: 'COCO项链',
    vtoType: '',
    extJson:
      '{"navigationbackpath":"/activities/2025/cococrush/pages/index/index?scene=plp"}',
    view3d: 0,
    createTimestamp: 1733476239767,
    isDeleted: false,
    updateTimestamp: 1736228541571
  },
  {
    id: 739,
    skuId: 'J13215',
    title: 'COCO项链',
    plpTitle: '["COCO", "项链"]',
    pdpTitle: '["COCO", "项链"]',
    description: '菱格纹图案，黄18K金，镶嵌钻石',
    plpDescription: '菱格纹图案，黄18K金\n镶嵌钻石',
    pdpDescription: '菱格纹图案，黄18K金，镶嵌钻石',
    price: 79200.0,
    localPrice: 0.0,
    isShow: '1',
    isPutOn: '0',
    plpTitleLine: 2,
    plpTitleType: 1,
    plpDescriptionLine: 1,
    pdpImgCount: 4,
    shareTitle: 'COCO项链',
    vtoType: '',
    extJson:
      '{"navigationbackpath":"/activities/2025/cococrush/pages/index/index?scene=plp"}',
    view3d: 0,
    createTimestamp: 1733476239447,
    isDeleted: false,
    updateTimestamp: 1736228541845
  },
  {
    id: 740,
    skuId: 'J13213',
    title: 'COCO CRUSH戒指',
    plpTitle: '["COCO CRUSH", "戒指"]',
    pdpTitle: '["COCO CRUSH", "戒指"]',
    description: '菱格纹图案，标准款，白18K金，镶嵌钻石',
    plpDescription: '菱格纹图案，标准款\n白18K金，镶嵌钻石',
    pdpDescription: '菱格纹图案，标准款，白18K金，镶嵌钻石',
    price: 46800.0,
    localPrice: 0.0,
    isShow: '1',
    isPutOn: '1',
    plpTitleLine: 2,
    plpTitleType: 1,
    plpDescriptionLine: 2,
    pdpImgCount: 1,
    shareTitle: '虚拟试戴COCO CRUSH戒指',
    vtoType: 'RING',
    extJson:
      '{"navigationbackpath":"/activities/2025/cococrush/pages/index/index?scene=plp"}',
    view3d: 0,
    createTimestamp: 1733476239176,
    isDeleted: false,
    updateTimestamp: 1736228542144
  },
  {
    id: 741,
    skuId: 'J13209',
    title: 'COCO CRUSH戒指',
    plpTitle: '["COCO CRUSH", "戒指"]',
    pdpTitle: '["COCO CRUSH", "戒指"]',
    description: '菱格纹图案，奢华款，黄18K金，镶嵌钻石',
    plpDescription: '菱格纹图案，奢华款\n黄18K金，镶嵌钻石',
    pdpDescription: '菱格纹图案，奢华款，黄18K金，镶嵌钻石',
    price: 98300.0,
    localPrice: 0.0,
    isShow: '1',
    isPutOn: '1',
    plpTitleLine: 2,
    plpTitleType: 1,
    plpDescriptionLine: 2,
    pdpImgCount: 1,
    shareTitle: '虚拟试戴COCO CRUSH戒指',
    vtoType: 'RING',
    extJson:
      '{"navigationbackpath":"/activities/2025/cococrush/pages/index/index?scene=plp"}',
    view3d: 0,
    createTimestamp: 1733476238906,
    isDeleted: false,
    updateTimestamp: 1736228542446
  },
  {
    id: 742,
    skuId: 'J13186',
    title: 'COCO CRUSH戒指',
    plpTitle: '["COCO CRUSH", "戒指"]',
    pdpTitle: '["COCO CRUSH", "戒指"]',
    description: '菱格纹图案，奢华款，白18K金，镶嵌钻石',
    plpDescription: '菱格纹图案，奢华款\n白18K金，镶嵌钻石',
    pdpDescription: '菱格纹图案，奢华款，白18K金，镶嵌钻石',
    price: 104800.0,
    localPrice: 0.0,
    isShow: '1',
    isPutOn: '1',
    plpTitleLine: 2,
    plpTitleType: 1,
    plpDescriptionLine: 2,
    pdpImgCount: 1,
    shareTitle: '虚拟试戴COCO CRUSH戒指',
    vtoType: 'RING',
    extJson:
      '{"navigationbackpath":"/activities/2025/cococrush/pages/index/index?scene=plp"}',
    view3d: 0,
    createTimestamp: 1733476238638,
    isDeleted: false,
    updateTimestamp: 1736228542705
  },
  {
    id: 743,
    skuId: 'J13163',
    title: 'COCO CRUSH戒指',
    plpTitle: '["COCO CRUSH", "戒指"]',
    pdpTitle: '["COCO CRUSH", "戒指"]',
    description: '菱格纹图案，标准款，黄18K金，镶嵌钻石',
    plpDescription: '菱格纹图案，标准款\n黄18K金，镶嵌钻石',
    pdpDescription: '菱格纹图案，标准款，黄18K金，镶嵌钻石',
    price: 43500.0,
    localPrice: 0.0,
    isShow: '1',
    isPutOn: '1',
    plpTitleLine: 2,
    plpTitleType: 1,
    plpDescriptionLine: 2,
    pdpImgCount: 1,
    shareTitle: '虚拟试戴COCO CRUSH戒指',
    vtoType: 'RING',
    extJson:
      '{"navigationbackpath":"/activities/2025/cococrush/pages/index/index?scene=plp"}',
    view3d: 0,
    createTimestamp: 1733476238361,
    isDeleted: false,
    updateTimestamp: 1736228542999
  },
  {
    id: 744,
    skuId: 'J13162',
    title: 'COCO CRUSH戒指',
    plpTitle: '["COCO CRUSH", "戒指"]',
    pdpTitle: '["COCO CRUSH", "戒指"]',
    description: '菱格纹图案，标准款，米色18K金，镶嵌钻石',
    plpDescription: '菱格纹图案，标准款\n米色18K金，镶嵌钻石',
    pdpDescription: '菱格纹图案，标准款，米色18K金，镶嵌钻石',
    price: 44300.0,
    localPrice: 0.0,
    isShow: '1',
    isPutOn: '1',
    plpTitleLine: 2,
    plpTitleType: 1,
    plpDescriptionLine: 2,
    pdpImgCount: 1,
    shareTitle: '虚拟试戴COCO CRUSH戒指',
    vtoType: 'RING',
    extJson:
      '{"navigationbackpath":"/activities/2025/cococrush/pages/index/index?scene=plp"}',
    view3d: 0,
    createTimestamp: 1733476238082,
    isDeleted: false,
    updateTimestamp: 1736228543253
  },
  {
    id: 745,
    skuId: 'J13161',
    title: 'COCO耳环',
    plpTitle: '["COCO", "耳环"]',
    pdpTitle: '["COCO", "耳环"]',
    description: '菱格纹图案，黄18K金',
    plpDescription: '菱格纹图案，黄18K金',
    pdpDescription: '菱格纹图案，黄18K金',
    price: 37500.0,
    localPrice: 0.0,
    isShow: '1',
    isPutOn: '0',
    plpTitleLine: 2,
    plpTitleType: 1,
    plpDescriptionLine: 1,
    pdpImgCount: 3,
    shareTitle: 'COCO耳环',
    vtoType: '',
    extJson:
      '{"navigationbackpath":"/activities/2025/cococrush/pages/index/index?scene=plp"}',
    view3d: 0,
    createTimestamp: 1733476237782,
    isDeleted: false,
    updateTimestamp: 1736228543502
  },
  {
    id: 746,
    skuId: 'J13160',
    title: 'COCO耳环',
    plpTitle: '["COCO", "耳环"]',
    pdpTitle: '["COCO", "耳环"]',
    description: '菱格纹图案，米色18K金',
    plpDescription: '菱格纹图案，米色18K金',
    pdpDescription: '菱格纹图案，米色18K金',
    price: 38200.0,
    localPrice: 0.0,
    isShow: '1',
    isPutOn: '0',
    plpTitleLine: 2,
    plpTitleType: 1,
    plpDescriptionLine: 1,
    pdpImgCount: 3,
    shareTitle: 'COCO耳环',
    vtoType: '',
    extJson:
      '{"navigationbackpath":"/activities/2025/cococrush/pages/index/index?scene=plp"}',
    view3d: 0,
    createTimestamp: 1733476237462,
    isDeleted: false,
    updateTimestamp: 1736228543770
  },
  {
    id: 747,
    skuId: 'J13156',
    title: 'COCO CRUSH戒指',
    plpTitle: '["COCO CRUSH", "戒指"]',
    pdpTitle: '["COCO CRUSH", "戒指"]',
    description: '菱格纹图案，奢华款，米色18K金，镶嵌钻石',
    plpDescription: '菱格纹图案，奢华款\n米色18K金，镶嵌钻石',
    pdpDescription: '菱格纹图案，奢华款，米色18K金，镶嵌钻石',
    price: 100000.0,
    localPrice: 0.0,
    isShow: '1',
    isPutOn: '1',
    plpTitleLine: 2,
    plpTitleType: 1,
    plpDescriptionLine: 2,
    pdpImgCount: 1,
    shareTitle: '虚拟试戴COCO CRUSH戒指',
    vtoType: 'RING',
    extJson:
      '{"navigationbackpath":"/activities/2025/cococrush/pages/index/index?scene=plp"}',
    view3d: 0,
    createTimestamp: 1733476237183,
    isDeleted: false,
    updateTimestamp: 1736228544041
  },
  {
    id: 748,
    skuId: 'J13084',
    title: 'COCO CRUSH手镯',
    plpTitle: '["COCO CRUSH", "手镯"]',
    pdpTitle: '["COCO CRUSH", "手镯"]',
    description: '菱格纹图案，精致款，米色18K金，镶嵌钻石',
    plpDescription: '菱格纹图案，精致款\n米色18K金，镶嵌钻石',
    pdpDescription: '菱格纹图案，精致款，米色18K金，镶嵌钻石',
    price: 116200.0,
    localPrice: 0.0,
    isShow: '1',
    isPutOn: '1',
    plpTitleLine: 2,
    plpTitleType: 1,
    plpDescriptionLine: 2,
    pdpImgCount: 3,
    shareTitle: '虚拟试戴COCO CRUSH手镯',
    vtoType: 'BRACELET',
    extJson:
      '{"navigationbackpath":"/activities/2025/cococrush/pages/index/index?scene=plp"}',
    view3d: 0,
    createTimestamp: 1733476236873,
    isDeleted: false,
    updateTimestamp: 1736228544413
  },
  {
    id: 749,
    skuId: 'J13080',
    title: 'COCO CRUSH手镯',
    plpTitle: '["COCO CRUSH", "手镯"]',
    pdpTitle: '["COCO CRUSH", "手镯"]',
    description: '菱格纹图案，精致款，黄18K金，镶嵌钻石',
    plpDescription: '菱格纹图案，精致款\n黄18K金，镶嵌钻石',
    pdpDescription: '菱格纹图案，精致款，黄18K金，镶嵌钻石',
    price: 113800.0,
    localPrice: 0.0,
    isShow: '1',
    isPutOn: '1',
    plpTitleLine: 2,
    plpTitleType: 1,
    plpDescriptionLine: 2,
    pdpImgCount: 3,
    shareTitle: '虚拟试戴COCO CRUSH手镯',
    vtoType: 'BRACELET',
    extJson:
      '{"navigationbackpath":"/activities/2025/cococrush/pages/index/index?scene=plp"}',
    view3d: 0,
    createTimestamp: 1733476236562,
    isDeleted: false,
    updateTimestamp: 1736228544716
  },
  {
    id: 750,
    skuId: 'J13001',
    title: 'COCO CRUSH戒指',
    plpTitle: '["COCO CRUSH", "戒指"]',
    pdpTitle: '["COCO CRUSH", "戒指"]',
    description: '菱格纹图案，标准款，米色18K金，镶嵌钻石',
    plpDescription: '菱格纹图案，标准款\n米色18K金，镶嵌钻石',
    pdpDescription: '菱格纹图案，标准款，米色18K金，镶嵌钻石',
    price: 129200.0,
    localPrice: 0.0,
    isShow: '1',
    isPutOn: '0',
    plpTitleLine: 2,
    plpTitleType: 1,
    plpDescriptionLine: 2,
    pdpImgCount: 4,
    shareTitle: '虚拟试戴COCO CRUSH戒指',
    vtoType: '',
    extJson:
      '{"navigationbackpath":"/activities/2025/cococrush/pages/index/index?scene=plp"}',
    view3d: 0,
    createTimestamp: 1733476236274,
    isDeleted: false,
    updateTimestamp: 1736228545009
  },
  {
    id: 751,
    skuId: 'J13000',
    title: 'COCO CRUSH戒指',
    plpTitle: '["COCO CRUSH", "戒指"]',
    pdpTitle: '["COCO CRUSH", "戒指"]',
    description: '菱格纹图案，标准款，黄18K金，镶嵌钻石',
    plpDescription: '菱格纹图案，标准款\n黄18K金，镶嵌钻石',
    pdpDescription: '菱格纹图案，标准款，黄18K金，镶嵌钻石',
    price: 126800.0,
    localPrice: 0.0,
    isShow: '1',
    isPutOn: '0',
    plpTitleLine: 2,
    plpTitleType: 1,
    plpDescriptionLine: 2,
    pdpImgCount: 4,
    shareTitle: '虚拟试戴COCO CRUSH戒指',
    vtoType: '',
    extJson:
      '{"navigationbackpath":"/activities/2025/cococrush/pages/index/index?scene=plp"}',
    view3d: 0,
    createTimestamp: 1733476235946,
    isDeleted: false,
    updateTimestamp: 1736228545274
  },
  {
    id: 752,
    skuId: 'J13043',
    title: 'COCO项链',
    plpTitle: '["COCO", "项链"]',
    pdpTitle: '["COCO", "项链"]',
    description: '菱格纹图案，米色18K金，镶嵌红宝石',
    plpDescription: '菱格纹图案，米色18K金\n镶嵌红宝石',
    pdpDescription: '菱格纹图案，米色18K金，镶嵌红宝石',
    price: 55300.0,
    localPrice: 0.0,
    isShow: '1',
    isPutOn: '0',
    plpTitleLine: 2,
    plpTitleType: 1,
    plpDescriptionLine: 2,
    pdpImgCount: 4,
    shareTitle: 'COCO项链',
    vtoType: '',
    extJson:
      '{"navigationbackpath":"/activities/2025/cococrush/pages/index/index?scene=plp"}',
    view3d: 0,
    createTimestamp: 1732097426008,
    isDeleted: false,
    updateTimestamp: 1733478078549
  },
  {
    id: 753,
    skuId: 'J13044',
    title: 'COCO手镯',
    plpTitle: '["COCO", "手链"]',
    pdpTitle: '["COCO", "手链"]',
    description: '菱格纹图案，米色18K金，镶嵌红宝石',
    plpDescription: '菱格纹图案，米色18K金\n镶嵌红宝石',
    pdpDescription: '菱格纹图案，米色18K金，镶嵌红宝石',
    price: 19500.0,
    localPrice: 0.0,
    isShow: '1',
    isPutOn: '0',
    plpTitleLine: 2,
    plpTitleType: 1,
    plpDescriptionLine: 2,
    pdpImgCount: 2,
    shareTitle: 'COCO手链',
    vtoType: '',
    extJson:
      '{"navigationbackpath":"/activities/2025/cococrush/pages/index/index?scene=plp"}',
    view3d: 0,
    createTimestamp: 1732097418500,
    isDeleted: false,
    updateTimestamp: 1733478090265
  },
  {
    id: 754,
    skuId: 'J12038',
    title: 'BOUTON DE CAMÉLIA耳环',
    plpTitle: '["BOUTON DE", "CAMÉLIA", "耳环"]',
    pdpTitle: '["BOUTON DE CAMÉLIA", "耳环"]',
    description: '黄18K金，镶嵌钻石',
    plpDescription: '黄18K金，镶嵌钻石',
    pdpDescription: '黄18K金，镶嵌钻石',
    price: 102800.0,
    localPrice: 0.0,
    isShow: '1',
    isPutOn: '0',
    plpTitleLine: 3,
    plpTitleType: 7,
    plpDescriptionLine: 1,
    pdpImgCount: 3,
    shareTitle: 'BOUTON DE CAMÉLIA耳环',
    vtoType: '',
    extJson:
      '{"navigationbackpath":"/activities/2024/j12/pages/landing/landing?scene=plp"}',
    view3d: 0,
    createTimestamp: 1729674380951,
    isDeleted: false,
    updateTimestamp: 1732075043958
  },
  {
    id: 755,
    skuId: 'J12440',
    title: 'Comète 1932耳环，可变换佩戴方式',
    plpTitle: '["COMÈTE 1932", "耳环"]',
    pdpTitle: '["COMÈTE 1932", "耳环"]',
    description: '白18K金，镶嵌钻石',
    plpDescription: '白18K金，镶嵌钻石\n可变换佩戴方式',
    pdpDescription: '白18K金，镶嵌钻石，可变换佩戴方式',
    price: 92600.0,
    localPrice: 0.0,
    isShow: '1',
    isPutOn: '0',
    plpTitleLine: 2,
    plpTitleType: 1,
    plpDescriptionLine: 2,
    pdpImgCount: 4,
    shareTitle: 'COMÈTE 1932耳环',
    vtoType: '',
    extJson:
      '{"navigationbackpath":"/activities/2024/eoy/pages/index/index?scene=plp"}',
    view3d: 0,
    createTimestamp: 1729674371155,
    isDeleted: false,
    updateTimestamp: 1732075131648
  },
  {
    id: 756,
    skuId: 'J12124',
    title: 'COMÈTE 1932耳环',
    plpTitle: '["COMÈTE 1932", "耳环"]',
    pdpTitle: '["COMÈTE 1932", "耳环"]',
    description: '白18K金，镶嵌钻石',
    plpDescription: '白18K金，镶嵌钻石',
    pdpDescription: '白18K金，镶嵌钻石',
    price: 98300.0,
    localPrice: 0.0,
    isShow: '1',
    isPutOn: '0',
    plpTitleLine: 2,
    plpTitleType: 1,
    plpDescriptionLine: 1,
    pdpImgCount: 3,
    shareTitle: 'COMÈTE 1932耳环',
    vtoType: '',
    extJson:
      '{"navigationbackpath":"/activities/2024/eoy/pages/index/index?scene=plp"}',
    view3d: 0,
    createTimestamp: 1729674366898,
    isDeleted: false,
    updateTimestamp: 1732075131224
  },
  {
    id: 757,
    skuId: 'J12838',
    title: 'BOUTON DE CAMÉLIA耳环，可变换佩戴方式',
    plpTitle: '["BOUTON DE", "CAMÉLIA", "耳环"]',
    pdpTitle: '["BOUTON DE CAMÉLIA", "耳环"]',
    description: '黄18K金，镶嵌钻石',
    plpDescription: '黄18K金，镶嵌钻石\n可变换佩戴方式',
    pdpDescription: '黄18K金，镶嵌钻石，可变换佩戴方式',
    price: 264100.0,
    localPrice: 0.0,
    isShow: '1',
    isPutOn: '0',
    plpTitleLine: 3,
    plpTitleType: 7,
    plpDescriptionLine: 2,
    pdpImgCount: 4,
    shareTitle: 'BOUTON DE CAMÉLIA耳环',
    vtoType: '',
    extJson:
      '{"navigationbackpath":"/activities/2024/eoy/pages/index/index?scene=plp"}',
    view3d: 0,
    createTimestamp: 1729674358987,
    isDeleted: false,
    updateTimestamp: 1732075130774
  },
  {
    id: 758,
    skuId: 'H6589',
    title: 'BOY·FRIEND腕表',
    plpTitle: '["BOY·FRIEND", "腕表"]',
    pdpTitle: '["BOY·FRIEND", "腕表"]',
    description: '大号款，米色18K金，菱格纹绗缝小牛皮表带，另附一条表带',
    plpDescription: '大号款，米色18K金\n菱格纹绗缝小牛皮表带\n另附一条表带',
    pdpDescription: '大号款，米色18K金，菱格纹绗缝小牛皮表带\n另附一条表带',
    price: 156900.0,
    localPrice: 0.0,
    isShow: '1',
    isPutOn: '0',
    plpTitleLine: 2,
    plpTitleType: 1,
    plpDescriptionLine: 3,
    pdpImgCount: 1,
    shareTitle: 'BOY·FRIEND腕表',
    vtoType: '',
    extJson:
      '{"navigationbackpath":"/activities/2024/eoy/pages/index/index?scene=plp"}',
    view3d: 0,
    createTimestamp: 1729673281698,
    isDeleted: false,
    updateTimestamp: 1732075130328
  },
  {
    id: 759,
    skuId: 'J12938',
    title: 'ETERNAL N°5项链',
    plpTitle: '["ETERNAL N°5", "项链"]',
    pdpTitle: '["ETERNAL N°5", "项链"]',
    description: '黄18K金，镶嵌钻石',
    plpDescription: '黄18K金，镶嵌钻石',
    pdpDescription: '黄18K金，镶嵌钻石',
    price: 74100.0,
    localPrice: 0.0,
    isShow: '1',
    isPutOn: '0',
    plpTitleLine: 2,
    plpTitleType: 1,
    plpDescriptionLine: 1,
    pdpImgCount: 4,
    shareTitle: 'ETERNAL N°5项链',
    vtoType: '',
    extJson:
      '{"navigationbackpath":"/activities/2024/eoy/pages/index/index?scene=plp"}',
    view3d: 0,
    createTimestamp: 1729673277333,
    isDeleted: false,
    updateTimestamp: 1732075129879
  },
  {
    id: 760,
    skuId: 'J12037',
    title: 'BOUTON DE CAMÉLIA项链',
    plpTitle: '["BOUTON DE", "CAMÉLIA", "项链"]',
    pdpTitle: '["BOUTON DE CAMÉLIA", "项链"]',
    description: '黄18K金，镶嵌钻石',
    plpDescription: '黄18K金，镶嵌钻石',
    pdpDescription: '黄18K金，镶嵌钻石',
    price: 63500.0,
    localPrice: 0.0,
    isShow: '1',
    isPutOn: '0',
    plpTitleLine: 3,
    plpTitleType: 7,
    plpDescriptionLine: 1,
    pdpImgCount: 4,
    shareTitle: 'BOUTON DE CAMÉLIA项链',
    vtoType: '',
    extJson:
      '{"navigationbackpath":"/activities/2024/eoy/pages/index/index?scene=plp"}',
    view3d: 0,
    createTimestamp: 1729673272622,
    isDeleted: false,
    updateTimestamp: 1732075129174
  },
  {
    id: 761,
    skuId: 'J10813',
    title: 'ÉTOILE FILANTE项链',
    plpTitle: '["ÉTOILE FILANTE", "项链"]',
    pdpTitle: '["ÉTOILE FILANTE", "项链"]',
    description: '白18K金，镶嵌钻石',
    plpDescription: '白18K金，镶嵌钻石',
    pdpDescription: '白18K金，镶嵌钻石',
    price: 52000.0,
    localPrice: 0.0,
    isShow: '1',
    isPutOn: '0',
    plpTitleLine: 2,
    plpTitleType: 1,
    plpDescriptionLine: 1,
    pdpImgCount: 4,
    shareTitle: 'ÉTOILE FILANTE项链',
    vtoType: '',
    extJson:
      '{"navigationbackpath":"/activities/2024/eoy/pages/index/index?scene=plp"}',
    view3d: 0,
    createTimestamp: 1729673267863,
    isDeleted: false,
    updateTimestamp: 1732075128737
  },
  {
    id: 762,
    skuId: 'J12128',
    title: 'LES INFINIS DE COMÈTE',
    plpTitle: '["LES INFINIS DE", "COMÈTE", "项链"]',
    pdpTitle: '["LES INFINIS DE COMÈTE", "项链"]',
    description: '长项链，白18K金，镶嵌钻石，可变换佩戴方式',
    plpDescription: '长项链，白18K金，镶嵌钻石\n可变换佩戴方式',
    pdpDescription: '长项链，白18K金，镶嵌钻石，可变换佩戴方式',
    price: 417800.0,
    localPrice: 0.0,
    isShow: '1',
    isPutOn: '0',
    plpTitleLine: 3,
    plpTitleType: 7,
    plpDescriptionLine: 2,
    pdpImgCount: 3,
    shareTitle: 'LES INFINIS DE COMÈTE项链',
    vtoType: '',
    extJson:
      '{"navigationbackpath":"/activities/2024/eoy/pages/index/index?scene=plp"}',
    view3d: 0,
    createTimestamp: 1729673264063,
    isDeleted: false,
    updateTimestamp: 1732075128310
  },
  {
    id: 763,
    skuId: 'J12848',
    title: 'RUBAN项链',
    plpTitle: '["RUBAN", "项链"]',
    pdpTitle: '["RUBAN", "项链"]',
    description: '玫瑰18K金，镶嵌钻石',
    plpDescription: '玫瑰18K金，镶嵌钻石',
    pdpDescription: '玫瑰18K金，镶嵌钻石',
    price: 73100.0,
    localPrice: 0.0,
    isShow: '1',
    isPutOn: '0',
    plpTitleLine: 2,
    plpTitleType: 1,
    plpDescriptionLine: 1,
    pdpImgCount: 2,
    shareTitle: 'RUBAN项链',
    vtoType: '',
    extJson:
      '{"navigationbackpath":"/activities/2024/eoy/pages/index/index?scene=plp"}',
    view3d: 0,
    createTimestamp: 1729673255993,
    isDeleted: false,
    updateTimestamp: 1732075127838
  },
  {
    id: 764,
    skuId: 'J12778',
    title: 'BOUTON DE CAMÉLIA短项链',
    plpTitle: '["BOUTON DE", "CAMÉLIA", "短项链"]',
    pdpTitle: '["BOUTON DE CAMÉLIA", "短项链"]',
    description: '黄18K金，镶嵌钻石',
    plpDescription: '黄18K金，镶嵌钻石',
    pdpDescription: '黄18K金，镶嵌钻石',
    price: 365800.0,
    localPrice: 0.0,
    isShow: '1',
    isPutOn: '0',
    plpTitleLine: 3,
    plpTitleType: 7,
    plpDescriptionLine: 1,
    pdpImgCount: 3,
    shareTitle: 'BOUTON DE CAMÉLIA短项链',
    vtoType: '',
    extJson:
      '{"navigationbackpath":"/activities/2024/eoy/pages/index/index?scene=plp"}',
    view3d: 0,
    createTimestamp: 1729673251133,
    isDeleted: false,
    updateTimestamp: 1732075127343
  },
  {
    id: 765,
    skuId: 'J12901',
    title: 'LES INFINIS DE N°5',
    plpTitle: '["LES INFINIS DE", "N°5", "项链"]',
    pdpTitle: '["LES INFINIS DE N°5", "项链"]',
    description: '长项链，白18K金，镶嵌钻石，可变换佩戴方式',
    plpDescription: '长项链，白18K金，镶嵌钻石\n可变换佩戴方式',
    pdpDescription: '长项链，白18K金，镶嵌钻石，可变换佩戴方式',
    price: 386000.0,
    localPrice: 0.0,
    isShow: '1',
    isPutOn: '0',
    plpTitleLine: 3,
    plpTitleType: 7,
    plpDescriptionLine: 2,
    pdpImgCount: 3,
    shareTitle: 'LES INFINIS DE N°5项链',
    vtoType: '',
    extJson:
      '{"navigationbackpath":"/activities/2024/eoy/pages/index/index?scene=plp"}',
    view3d: 0,
    createTimestamp: 1729673246248,
    isDeleted: false,
    updateTimestamp: 1732075126904
  },
  {
    id: 766,
    skuId: 'J12121',
    title: 'BOUTON DE CAMÉLIA戒指',
    plpTitle: '["BOUTON DE", "CAMÉLIA", "戒指"]',
    pdpTitle: '["BOUTON DE CAMÉLIA", "戒指"]',
    description: '黄18K金，镶嵌钻石',
    plpDescription: '黄18K金，镶嵌钻石',
    pdpDescription: '黄18K金，镶嵌钻石',
    price: 131800.0,
    localPrice: 0.0,
    isShow: '1',
    isPutOn: '0',
    plpTitleLine: 3,
    plpTitleType: 7,
    plpDescriptionLine: 1,
    pdpImgCount: 1,
    shareTitle: 'BOUTON DE CAMÉLIA戒指',
    vtoType: '',
    extJson:
      '{"navigationbackpath":"/activities/2024/eoy/pages/index/index?scene=plp"}',
    view3d: 0,
    createTimestamp: 1729671186188,
    isDeleted: false,
    updateTimestamp: 1732075126264
  },
  {
    id: 767,
    skuId: 'J12118',
    title: 'COMÈTE 1932戒指',
    plpTitle: '["COMÈTE 1932", "戒指"]',
    pdpTitle: '["COMÈTE 1932", "戒指"]',
    description: '白18K金，镶嵌钻石',
    plpDescription: '白18K金，镶嵌钻石',
    pdpDescription: '白18K金，镶嵌钻石',
    price: 182000.0,
    localPrice: 0.0,
    isShow: '1',
    isPutOn: '0',
    plpTitleLine: 2,
    plpTitleType: 1,
    plpDescriptionLine: 1,
    pdpImgCount: 3,
    shareTitle: 'COMÈTE 1932戒指',
    vtoType: '',
    extJson:
      '{"navigationbackpath":"/activities/2024/eoy/pages/index/index?scene=plp"}',
    view3d: 0,
    createTimestamp: 1729671179378,
    isDeleted: false,
    updateTimestamp: 1732075125814
  },
  {
    id: 768,
    skuId: 'J2643',
    title: 'ULTRA戒指',
    plpTitle: '["ULTRA", "戒指"]',
    pdpTitle: '["ULTRA", "戒指"]',
    description: '标准款，白18K金，镶嵌钻石，白色陶瓷',
    plpDescription: '标准款，白18K金\n镶嵌钻石，白色陶瓷',
    pdpDescription: '标准款，白18K金，镶嵌钻石，白色陶瓷',
    price: 48500.0,
    localPrice: 0.0,
    isShow: '1',
    isPutOn: '0',
    plpTitleLine: 2,
    plpTitleType: 1,
    plpDescriptionLine: 2,
    pdpImgCount: 1,
    shareTitle: 'ULTRA戒指',
    vtoType: '',
    extJson:
      '{"navigationbackpath":"/activities/2024/eoy/pages/index/index?scene=plp"}',
    view3d: 0,
    createTimestamp: 1729671175118,
    isDeleted: false,
    updateTimestamp: 1732075125378
  },
  {
    id: 769,
    skuId: 'J12369',
    title: 'Camélia Bloom戒指',
    plpTitle: '["CAMÉLIA BLOOM", "戒指"]',
    pdpTitle: '["CAMÉLIA BLOOM", "戒指"]',
    description: '白18K金，镶嵌钻石',
    plpDescription: '白18K金，镶嵌钻石',
    pdpDescription: '白18K金，镶嵌钻石',
    price: 341300.0,
    localPrice: 0.0,
    isShow: '1',
    isPutOn: '0',
    plpTitleLine: 2,
    plpTitleType: 1,
    plpDescriptionLine: 1,
    pdpImgCount: 2,
    shareTitle: 'CAMÉLIA BLOOM戒指',
    vtoType: '',
    extJson:
      '{"navigationbackpath":"/activities/2024/eoy/pages/index/index?scene=plp"}',
    view3d: 0,
    createTimestamp: 1729671167767,
    isDeleted: false,
    updateTimestamp: 1734345501460
  },
  {
    id: 770,
    skuId: 'J11935',
    title: 'PLUME DE CHANEL戒指',
    plpTitle: '["PLUME DE CHANEL", "戒指"]',
    pdpTitle: '["PLUME DE CHANEL", "戒指"]',
    description: '白18K金与黄18K金，镶嵌钻石',
    plpDescription: '白18K金与黄18K金\n镶嵌钻石',
    pdpDescription: '白18K金与黄18K金，镶嵌钻石',
    price: 407200.0,
    localPrice: 0.0,
    isShow: '1',
    isPutOn: '0',
    plpTitleLine: 2,
    plpTitleType: 1,
    plpDescriptionLine: 2,
    pdpImgCount: 2,
    shareTitle: 'PLUME DE CHANEL戒指',
    vtoType: '',
    extJson:
      '{"navigationbackpath":"/activities/2024/eoy/pages/index/index?scene=plp"}',
    view3d: 0,
    createTimestamp: 1729671161056,
    isDeleted: false,
    updateTimestamp: 1732075124490
  },
  {
    id: 771,
    skuId: 'J12208',
    title: 'LUNE戒指',
    plpTitle: '["LUNE", "戒指"]',
    pdpTitle: '["LUNE", "戒指"]',
    description: '白18K金，镶嵌钻石',
    plpDescription: '白18K金，镶嵌钻石',
    pdpDescription: '白18K金，镶嵌钻石',
    price: 126800.0,
    localPrice: 0.0,
    isShow: '1',
    isPutOn: '0',
    plpTitleLine: 2,
    plpTitleType: 1,
    plpDescriptionLine: 1,
    pdpImgCount: 2,
    shareTitle: 'LUNE戒指',
    vtoType: '',
    extJson:
      '{"navigationbackpath":"/activities/2024/eoy/pages/index/index?scene=plp"}',
    view3d: 0,
    createTimestamp: 1729671155095,
    isDeleted: false,
    updateTimestamp: 1732075124029
  },
  {
    id: 772,
    skuId: 'J12065',
    title: 'BOUTON DE CAMÉLIA手链',
    plpTitle: '["BOUTON DE", "CAMÉLIA", "手链"]',
    pdpTitle: '["BOUTON DE CAMÉLIA", "手链"]',
    description: '白18K金，镶嵌钻石',
    plpDescription: '白18K金，镶嵌钻石',
    pdpDescription: '白18K金，镶嵌钻石',
    price: 230000.0,
    localPrice: 0.0,
    isShow: '1',
    isPutOn: '0',
    plpTitleLine: 3,
    plpTitleType: 7,
    plpDescriptionLine: 1,
    pdpImgCount: 4,
    shareTitle: 'BOUTON DE CAMÉLIA手链',
    vtoType: '',
    extJson:
      '{"navigationbackpath":"/activities/2024/eoy/pages/index/index?scene=plp"}',
    view3d: 0,
    createTimestamp: 1729669899209,
    isDeleted: false,
    updateTimestamp: 1732075123582
  },
  {
    id: 773,
    skuId: 'J11491',
    title: 'COMÈTE CHEVRON手镯',
    plpTitle: '["COMÈTE CHEVRON", "手镯"]',
    pdpTitle: '["COMÈTE CHEVRON", "手镯"]',
    description: '白18K金，镶嵌钻石',
    plpDescription: '白18K金，镶嵌钻石',
    pdpDescription: '白18K金，镶嵌钻石',
    price: 139000.0,
    localPrice: 0.0,
    isShow: '1',
    isPutOn: '0',
    plpTitleLine: 2,
    plpTitleType: 1,
    plpDescriptionLine: 1,
    pdpImgCount: 2,
    shareTitle: 'COMÈTE CHEVRON手镯',
    vtoType: '',
    extJson:
      '{"navigationbackpath":"/activities/2024/eoy/pages/index/index?scene=plp"}',
    view3d: 0,
    createTimestamp: 1729669558607,
    isDeleted: false,
    updateTimestamp: 1732075123158
  },
  {
    id: 774,
    skuId: 'H9836',
    title: 'J12 DIAMOND BEZEL CALIBER 12.1腕表，38毫米',
    plpTitle: '["J12 DIAMOND","BEZEL CALIBER","12.1","腕表","38","毫米"]',
    pdpTitle: '["J12 DIAMOND BEZEL", "CALIBER 12.1", "腕表", "38", "毫米"]',
    description: '白色精密陶瓷和黄18K金，表圈和时标镶嵌钻石',
    plpDescription: '白色精密陶瓷和黄18K金\n表圈和时标镶嵌钻石',
    pdpDescription: '白色精密陶瓷和黄18K金，表圈和时标镶嵌钻石',
    price: 223500.0,
    localPrice: 0.0,
    isShow: '1',
    isPutOn: '0',
    plpTitleLine: 4,
    plpTitleType: 5,
    plpDescriptionLine: 2,
    pdpImgCount: 2,
    shareTitle: '虚拟试戴J12腕表',
    vtoType: '',
    extJson:
      '{"navigationbackpath":"/activities/2024/j12/pages/landing/landing?scene=plp"}',
    view3d: 0,
    createTimestamp: 1726629890148,
    isDeleted: false,
    updateTimestamp: 1732075122710
  },
  {
    id: 775,
    skuId: 'H9837',
    title: 'J12 DIAMOND BEZEL CALIBER 12.1腕表，38毫米',
    plpTitle: '["J12 DIAMOND","BEZEL CALIBER","12.1","腕表","38","毫米"]',
    pdpTitle: '["J12 DIAMOND BEZEL", "CALIBER 12.1", "腕表", "38", "毫米"]',
    description: '黑色精密陶瓷和黄18K金，表圈和时标镶嵌钻石',
    plpDescription: '黑色精密陶瓷和黄18K金\n表圈和时标镶嵌钻石',
    pdpDescription: '黑色精密陶瓷和黄18K金，表圈和时标镶嵌钻石',
    price: 223500.0,
    localPrice: 0.0,
    isShow: '1',
    isPutOn: '0',
    plpTitleLine: 4,
    plpTitleType: 5,
    plpDescriptionLine: 2,
    pdpImgCount: 2,
    shareTitle: '虚拟试戴J12腕表',
    vtoType: '',
    extJson:
      '{"navigationbackpath":"/activities/2024/j12/pages/landing/landing?scene=plp"}',
    view3d: 0,
    createTimestamp: 1726629882156,
    isDeleted: false,
    updateTimestamp: 1732075122278
  },
  {
    id: 776,
    skuId: 'H10473',
    title: 'J12 DIAMOND BEZEL CALIBER 12.2腕表，33毫米',
    plpTitle: '["J12 DIAMOND","BEZEL CALIBER","12.2","腕表","33","毫米"]',
    pdpTitle: '["J12 DIAMOND BEZEL", "CALIBER 12.2", "腕表", "33", "毫米"]',
    description: '白色精密陶瓷和精钢，表圈和时标镶嵌钻石',
    plpDescription: '白色精密陶瓷和精钢\n表圈和时标镶嵌钻石',
    pdpDescription: '白色精密陶瓷和精钢，表圈和时标镶嵌钻石',
    price: 138600.0,
    localPrice: 0.0,
    isShow: '1',
    isPutOn: '0',
    plpTitleLine: 4,
    plpTitleType: 5,
    plpDescriptionLine: 2,
    pdpImgCount: 1,
    shareTitle: '虚拟试戴J12腕表',
    vtoType: '',
    extJson:
      '{"navigationbackpath":"/activities/2024/j12/pages/landing/landing?scene=plp"}',
    view3d: 0,
    createTimestamp: 1726629874208,
    isDeleted: false,
    updateTimestamp: 1732075121806
  },
  {
    id: 777,
    skuId: 'H10474',
    title: 'J12 DIAMOND BEZEL CALIBER 12.2腕表，33毫米',
    plpTitle: '["J12 DIAMOND","BEZEL CALIBER","12.2","腕表","33","毫米"]',
    pdpTitle: '["J12 DIAMOND BEZEL", "CALIBER 12.2", "腕表", "33", "毫米"]',
    description: '黑色精密陶瓷和精钢，表圈和时标镶嵌钻石',
    plpDescription: '黑色精密陶瓷和精钢\n表圈和时标镶嵌钻石',
    pdpDescription: '黑色精密陶瓷和精钢，表圈和时标镶嵌钻石',
    price: 138600.0,
    localPrice: 0.0,
    isShow: '1',
    isPutOn: '0',
    plpTitleLine: 4,
    plpTitleType: 5,
    plpDescriptionLine: 2,
    pdpImgCount: 1,
    shareTitle: '虚拟试戴J12腕表',
    vtoType: '',
    extJson:
      '{"navigationbackpath":"/activities/2024/j12/pages/landing/landing?scene=plp"}',
    view3d: 0,
    createTimestamp: 1726629864675,
    isDeleted: false,
    updateTimestamp: 1732075121373
  },
  {
    id: 778,
    skuId: 'H10472',
    title: 'J12 CALIBER 12.2腕表，33毫米',
    plpTitle: '["J12 CALIBER 12.2", "腕表", "33", "毫米"]',
    pdpTitle: '["J12 CALIBER 12.2", "腕表", "33", "毫米"]',
    description: '白色精密陶瓷和精钢，钻石时标，白色珍珠母贝表盘',
    plpDescription: '白色精密陶瓷和精钢\n钻石时标，白色珍珠母贝表盘',
    pdpDescription: '白色精密陶瓷和精钢，钻石时标，白色珍珠母贝表盘',
    price: 76500.0,
    localPrice: 0.0,
    isShow: '1',
    isPutOn: '0',
    plpTitleLine: 2,
    plpTitleType: 2,
    plpDescriptionLine: 2,
    pdpImgCount: 1,
    shareTitle: '虚拟试戴J12腕表',
    vtoType: '',
    extJson:
      '{"navigationbackpath":"/activities/2024/j12/pages/landing/landing?scene=plp"}',
    view3d: 0,
    createTimestamp: 1726629676525,
    isDeleted: false,
    updateTimestamp: 1732075120949
  },
  {
    id: 779,
    skuId: 'H10166',
    title: 'Première Sound耳机时计',
    plpTitle: '["PREMIÈRE SOUND", "耳机时计"]',
    pdpTitle: '["PREMIÈRE SOUND", "耳机时计"]',
    description:
      '黄18K金镀层（0.1微米）精钢和黑色皮革，黑色漆面表盘，黑色和金色镀层精钢耳机',
    plpDescription: '黄18K金镀层（0.1微米）精钢\n和黑色皮革，黑色漆面表盘',
    pdpDescription:
      '黄18K金镀层（0.1微米）精钢和黑色皮革\n黑色漆面表盘，黑色和金色镀层精钢耳机',
    price: 120300.0,
    localPrice: 0.0,
    isShow: '1',
    isPutOn: '0',
    plpTitleLine: 2,
    plpTitleType: 1,
    plpDescriptionLine: 2,
    pdpImgCount: 5,
    shareTitle: '虚拟试戴PREMIÈRE腕表',
    vtoType: '',
    extJson:
      '{"navigationbackpath":"/activities/2024/premiere-sound/pages/index/index?scene=plp"}',
    view3d: 0,
    createTimestamp: 1722932268658,
    isDeleted: false,
    updateTimestamp: 1732075120526
  },
  {
    id: 780,
    skuId: 'H9861',
    title: 'PREMIÈRE铐式手镯腕表',
    plpTitle: '["PREMIÈRE", "铐式手镯腕表"]',
    pdpTitle: '["PREMIÈRE", "铐式手镯腕表"]',
    description: '黄18K金镀层（0.1微米）精钢和黑色皮革，黑色漆面表盘',
    plpDescription: '黄18K金镀层（0.1微米）精钢\n和黑色皮革，黑色漆面表盘',
    pdpDescription: '黄18K金镀层（0.1微米）精钢和黑色皮革\n黑色漆面表盘',
    price: 87100.0,
    localPrice: 0.0,
    isShow: '1',
    isPutOn: '0',
    plpTitleLine: 2,
    plpTitleType: 1,
    plpDescriptionLine: 2,
    pdpImgCount: 1,
    shareTitle: '虚拟试戴PREMIÈRE腕表',
    vtoType: '',
    extJson:
      '{"navigationbackpath":"/activities/2024/premiere-sound/pages/index/index?scene=plp"}',
    view3d: 0,
    createTimestamp: 1722932267246,
    isDeleted: false,
    updateTimestamp: 1732075120098
  },
  {
    id: 781,
    skuId: 'H9860',
    title: 'PREMIÈRE长链条款时计',
    plpTitle: '["PREMIÈRE", "长链条款时计"]',
    pdpTitle: '["PREMIÈRE", "长链条款时计"]',
    description: '黄18K金镀层（0.1微米）精钢和黑色皮革，黑色漆面表盘',
    plpDescription: '黄18K金镀层（0.1微米）精钢\n和黑色皮革，黑色漆面表盘',
    pdpDescription: '黄18K金镀层（0.1微米）精钢和黑色皮革\n黑色漆面表盘',
    price: 97500.0,
    localPrice: 0.0,
    isShow: '1',
    isPutOn: '0',
    plpTitleLine: 2,
    plpTitleType: 1,
    plpDescriptionLine: 2,
    pdpImgCount: 1,
    shareTitle: '虚拟试戴PREMIÈRE腕表',
    vtoType: '',
    extJson:
      '{"navigationbackpath":"/activities/2024/premiere-sound/pages/index/index?scene=plp"}',
    view3d: 0,
    createTimestamp: 1722932265869,
    isDeleted: false,
    updateTimestamp: 1732075119639
  },
  {
    id: 782,
    skuId: 'H7023',
    title: 'Première Iconic Chain腕表',
    plpTitle: '["Première Iconic", "Chain", "腕表"]',
    pdpTitle: '["Première Iconic", "Chain", "腕表"]',
    description: '精钢和黑色皮革，黑色表盘',
    plpDescription: '精钢和黑色皮革\n黑色表盘',
    pdpDescription: '精钢和黑色皮革，黑色表盘',
    price: 44800.0,
    localPrice: 0.0,
    isShow: '1',
    isPutOn: '0',
    plpTitleLine: 2,
    plpTitleType: 3,
    plpDescriptionLine: 2,
    pdpImgCount: 1,
    shareTitle: '虚拟试戴PREMIÈRE腕表',
    vtoType: '',
    extJson:
      '{"navigationbackpath":"/activities/2024/premiere-sound/pages/index/index?scene=plp"}',
    view3d: 0,
    createTimestamp: 1722932264230,
    isDeleted: false,
    updateTimestamp: 1732075118842
  },
  {
    id: 783,
    skuId: 'H7021',
    title: 'Première Gourmette Chain腕表',
    plpTitle: '["Première", "Gourmette", "Chain", "腕表"]',
    pdpTitle: '["Première Gourmette", "Chain", "腕表"]',
    description: '小号，精钢和钻石，黑色表盘',
    plpDescription: '小号，精钢和钻石\n黑色表盘',
    pdpDescription: '小号，精钢和钻石，黑色表盘',
    price: 64200.0,
    localPrice: 0.0,
    isShow: '1',
    isPutOn: '0',
    plpTitleLine: 3,
    plpTitleType: 6,
    plpDescriptionLine: 2,
    pdpImgCount: 1,
    shareTitle: '虚拟试戴PREMIÈRE腕表',
    vtoType: '',
    extJson:
      '{"navigationbackpath":"/activities/2024/premiere-sound/pages/index/index?scene=plp"}',
    view3d: 0,
    createTimestamp: 1722932262496,
    isDeleted: false,
    updateTimestamp: 1732075118402
  },
  {
    id: 784,
    skuId: 'H7020',
    title: 'Première Gourmette Chain腕表',
    plpTitle: '["Première", "Gourmette", "Chain", "腕表"]',
    pdpTitle: '["Première Gourmette", "Chain", "腕表"]',
    description: '大号，精钢和钻石，黑色表盘',
    plpDescription: '大号，精钢和钻石\n黑色表盘',
    pdpDescription: '大号，精钢和钻石，黑色表盘',
    price: 75600.0,
    localPrice: 0.0,
    isShow: '1',
    isPutOn: '0',
    plpTitleLine: 3,
    plpTitleType: 6,
    plpDescriptionLine: 2,
    pdpImgCount: 1,
    shareTitle: '虚拟试戴PREMIÈRE腕表',
    vtoType: '',
    extJson:
      '{"navigationbackpath":"/activities/2024/premiere-sound/pages/index/index?scene=plp"}',
    view3d: 0,
    createTimestamp: 1722932261414,
    isDeleted: false,
    updateTimestamp: 1732075117940
  },
  {
    id: 785,
    skuId: 'H2132',
    title: 'Première Ceramic腕表',
    plpTitle: '["Première Ceramic", "腕表"]',
    pdpTitle: '["Première Ceramic", "腕表"]',
    description: '精钢和白色精密陶瓷，镶钻，白色漆面表盘',
    plpDescription: '精钢和白色精密陶瓷\n镶钻，白色漆面表盘',
    pdpDescription: '精钢和白色精密陶瓷，镶钻，白色漆面表盘',
    price: 69900.0,
    localPrice: 0.0,
    isShow: '1',
    isPutOn: '0',
    plpTitleLine: 2,
    plpTitleType: 1,
    plpDescriptionLine: 2,
    pdpImgCount: 1,
    shareTitle: '虚拟试戴PREMIÈRE腕表',
    vtoType: '',
    extJson:
      '{"navigationbackpath":"/activities/2024/premiere-sound/pages/index/index?scene=plp"}',
    view3d: 0,
    createTimestamp: 1722932259936,
    isDeleted: false,
    updateTimestamp: 1732075117497
  },
  {
    id: 786,
    skuId: 'H6126',
    title: 'Première Ribbon腕表',
    plpTitle: '["Première Ribbon", "腕表"]',
    pdpTitle: '["Première Ribbon", "腕表"]',
    description: '黄18K金和钛金属，黑色丝绒质感橡胶，镶钻表盘',
    plpDescription: '黄18K金和钛金属\n黑色丝绒质感橡胶，镶钻表盘',
    pdpDescription: '黄18K金和钛金属，黑色丝绒质感橡胶，镶钻表盘',
    price: 92600.0,
    localPrice: 0.0,
    isShow: '1',
    isPutOn: '0',
    plpTitleLine: 2,
    plpTitleType: 1,
    plpDescriptionLine: 2,
    pdpImgCount: 1,
    shareTitle: '虚拟试戴PREMIÈRE腕表',
    vtoType: '',
    extJson:
      '{"navigationbackpath":"/activities/2024/premiere-sound/pages/index/index?scene=plp"}',
    view3d: 0,
    createTimestamp: 1722932258249,
    isDeleted: false,
    updateTimestamp: 1732075117043
  },
  {
    id: 787,
    skuId: 'H7019',
    title: 'Première Gourmette Chain腕表',
    plpTitle: '["Première", "Gourmette", "Chain", "腕表"]',
    pdpTitle: '["Première Gourmette", "Chain", "腕表"]',
    description: '小号，精钢，黑色表盘',
    plpDescription: '小号，精钢\n黑色表盘',
    pdpDescription: '小号，精钢，黑色表盘',
    price: 38200.0,
    localPrice: 0.0,
    isShow: '1',
    isPutOn: '0',
    plpTitleLine: 3,
    plpTitleType: 6,
    plpDescriptionLine: 2,
    pdpImgCount: 1,
    shareTitle: '虚拟试戴PREMIÈRE腕表',
    vtoType: '',
    extJson:
      '{"navigationbackpath":"/activities/2024/premiere-sound/pages/index/index?scene=plp"}',
    view3d: 0,
    createTimestamp: 1722932256764,
    isDeleted: false,
    updateTimestamp: 1732075116595
  },
  {
    id: 788,
    skuId: 'H2163',
    title: 'Première Ceramic腕表',
    plpTitle: '["Première Ceramic", "腕表"]',
    pdpTitle: '["Première Ceramic", "腕表"]',
    description: '精钢和黑色精密陶瓷，镶钻，黑色漆面表盘',
    plpDescription: '精钢和黑色精密陶瓷\n镶钻，黑色漆面表盘',
    pdpDescription: '精钢和黑色精密陶瓷，镶钻，黑色漆面表盘',
    price: 69900.0,
    localPrice: 0.0,
    isShow: '1',
    isPutOn: '0',
    plpTitleLine: 2,
    plpTitleType: 1,
    plpDescriptionLine: 2,
    pdpImgCount: 3,
    shareTitle: '虚拟试戴PREMIÈRE腕表',
    vtoType: '',
    extJson:
      '{"navigationbackpath":"/activities/2024/premiere-sound/pages/index/index?scene=plp"}',
    view3d: 0,
    createTimestamp: 1722932255334,
    isDeleted: false,
    updateTimestamp: 1732075116060
  },
  {
    id: 789,
    skuId: 'H7942',
    title: 'PREMIÈRE RIBBON腕表',
    plpTitle: '["PREMIÈRE RIBBON", "腕表"]',
    pdpTitle: '["PREMIÈRE RIBBON", "腕表"]',
    description: '精钢和钻石，黑色丝绒质感橡胶表带，黑色漆面表盘',
    plpDescription: '精钢和钻石\n黑色丝绒质感橡胶表带',
    pdpDescription: '精钢和钻石，黑色丝绒质感橡胶表带\n黑色漆面表盘',
    price: 50500.0,
    localPrice: 0.0,
    isShow: '1',
    isPutOn: '0',
    plpTitleLine: 2,
    plpTitleType: 1,
    plpDescriptionLine: 2,
    pdpImgCount: 1,
    shareTitle: '虚拟试戴PREMIÈRE腕表',
    vtoType: '',
    extJson:
      '{"navigationbackpath":"/activities/2024/premiere-sound/pages/index/index?scene=plp"}',
    view3d: 0,
    createTimestamp: 1722932253908,
    isDeleted: false,
    updateTimestamp: 1732075115418
  },
  {
    id: 790,
    skuId: 'H7018',
    title: 'Première Gourmette Chain腕表',
    plpTitle: '["Première", "Gourmette", "Chain", "腕表"]',
    pdpTitle: '["Première Gourmette", "Chain", "腕表"]',
    description: '大号，精钢，黑色表盘',
    plpDescription: '大号，精钢\n黑色表盘',
    pdpDescription: '大号，精钢，黑色表盘',
    price: 41000.0,
    localPrice: 0.0,
    isShow: '1',
    isPutOn: '0',
    plpTitleLine: 3,
    plpTitleType: 6,
    plpDescriptionLine: 2,
    pdpImgCount: 1,
    shareTitle: '虚拟试戴PREMIÈRE腕表',
    vtoType: '',
    extJson:
      '{"navigationbackpath":"/activities/2024/premiere-sound/pages/index/index?scene=plp"}',
    view3d: 0,
    createTimestamp: 1722932252462,
    isDeleted: false,
    updateTimestamp: 1732075114966
  },
  {
    id: 791,
    skuId: 'H9859',
    title: 'PREMIÈRE CHARMS COUTURE腕表',
    plpTitle: '["PREMIÈRE CHARMS", "COUTURE", "腕表"]',
    pdpTitle: '["PREMIÈRE CHARMS", "COUTURE", "腕表"]',
    description: '黄18K金镀层（0.1微米）精钢和黑色皮革，黑色漆面表盘',
    plpDescription: '黄18K金镀层（0.1微米）精钢\n和黑色皮革，黑色漆面表盘',
    pdpDescription: '黄18K金镀层（0.1微米）精钢和黑色皮革\n黑色漆面表盘',
    price: 85300.0,
    localPrice: 0.0,
    isShow: '1',
    isPutOn: '0',
    plpTitleLine: 2,
    plpTitleType: 3,
    plpDescriptionLine: 2,
    pdpImgCount: 1,
    shareTitle: '虚拟试戴PREMIÈRE腕表',
    vtoType: '',
    extJson:
      '{"navigationbackpath":"/activities/2024/premiere-sound/pages/index/index?scene=plp"}',
    view3d: 0,
    createTimestamp: 1722932250810,
    isDeleted: false,
    updateTimestamp: 1732075114394
  },
  {
    id: 792,
    skuId: 'H9858',
    title: 'PREMIÈRE RIBBON COUTURE腕表',
    plpTitle: '["PREMIÈRE RIBBON", "COUTURE", "腕表"]',
    pdpTitle: '["PREMIÈRE RIBBON", "COUTURE", "腕表"]',
    description:
      '黄18K金，双重环绕式皮革表带，饰以印花图案，金色皮革滚边和底衬，黑色漆面表盘',
    plpDescription: '黄18K金\n双重环绕式皮革表带',
    pdpDescription:
      '黄18K金，双重环绕式皮革表带，饰以印花图案\n金色皮革滚边和底衬，黑色漆面表盘',
    price: 81300.0,
    localPrice: 0.0,
    isShow: '1',
    isPutOn: '0',
    plpTitleLine: 2,
    plpTitleType: 3,
    plpDescriptionLine: 2,
    pdpImgCount: 1,
    shareTitle: '虚拟试戴PREMIÈRE腕表',
    vtoType: '',
    extJson:
      '{"navigationbackpath":"/activities/2024/premiere-sound/pages/index/index?scene=plp"}',
    view3d: 0,
    createTimestamp: 1722932249238,
    isDeleted: false,
    updateTimestamp: 1732075113740
  },
  {
    id: 793,
    skuId: 'H6125',
    title: 'Première Ribbon腕表',
    plpTitle: '["Première Ribbon", "腕表"]',
    pdpTitle: '["Première Ribbon", "腕表"]',
    description: '黄18K金和钛金属，黑色丝绒质感橡胶，黑色漆面表盘',
    plpDescription: '黄18K金和钛金属\n黑色丝绒质感橡胶',
    pdpDescription: '黄18K金和钛金属，黑色丝绒质感橡胶\n黑色漆面表盘',
    price: 44800.0,
    localPrice: 0.0,
    isShow: '1',
    isPutOn: '0',
    plpTitleLine: 2,
    plpTitleType: 1,
    plpDescriptionLine: 2,
    pdpImgCount: 2,
    shareTitle: '虚拟试戴PREMIÈRE腕表',
    vtoType: '',
    extJson:
      '{"navigationbackpath":"/activities/2024/premiere-sound/pages/index/index?scene=plp"}',
    view3d: 0,
    createTimestamp: 1722932247342,
    isDeleted: false,
    updateTimestamp: 1732075113313
  },
  {
    id: 794,
    skuId: 'H7022',
    title: 'Première Iconic Chain腕表',
    plpTitle: '["Première Iconic", "Chain", "腕表"]',
    pdpTitle: '["Première Iconic", "Chain", "腕表"]',
    description: '精钢和黑色皮革，黑色表盘',
    plpDescription: '精钢和黑色皮革\n黑色表盘',
    pdpDescription: '精钢和黑色皮革，黑色表盘',
    price: 44800.0,
    localPrice: 0.0,
    isShow: '1',
    isPutOn: '0',
    plpTitleLine: 2,
    plpTitleType: 3,
    plpDescriptionLine: 2,
    pdpImgCount: 1,
    shareTitle: '虚拟试戴PREMIÈRE腕表',
    vtoType: '',
    extJson:
      '{"navigationbackpath":"/activities/2024/premiere-sound/pages/index/index?scene=plp"}',
    view3d: 0,
    createTimestamp: 1722932246318,
    isDeleted: false,
    updateTimestamp: 1732075112796
  },
  {
    id: 795,
    skuId: 'J12155',
    title: 'COCO CRUSH单只耳环',
    plpTitle: '["COCO CRUSH", "单只耳环"]',
    pdpTitle: '["COCO CRUSH", "单只耳环"]',
    description: '菱格纹图案，米色18K金，镶嵌钻石',
    plpDescription: '菱格纹图案\n米色18K金，镶嵌钻石',
    pdpDescription: '菱格纹图案，米色18K金，镶嵌钻石',
    price: 18200.0,
    localPrice: 0.0,
    isShow: '1',
    isPutOn: '0',
    plpTitleLine: 2,
    plpTitleType: 1,
    plpDescriptionLine: 2,
    pdpImgCount: 3,
    shareTitle: 'COCO CRUSH单只耳环',
    vtoType: '',
    extJson:
      '{"navigationbackpath":"/activities/2025/cococrush/pages/index/index?scene=plp"}',
    view3d: 1,
    createTimestamp: 1720004319787,
    isDeleted: false,
    updateTimestamp: 1732075112338
  },
  {
    id: 796,
    skuId: 'J10573',
    title: 'COCO CRUSH戒指',
    plpTitle: '["COCO CRUSH", "戒指"]',
    pdpTitle: '["COCO CRUSH", "戒指"]',
    description: '菱格纹图案，奢华款，白18K金',
    plpDescription: '菱格纹图案，奢华款\n白18K金',
    pdpDescription: '菱格纹图案，奢华款，白18K金',
    price: 34900.0,
    localPrice: 0.0,
    isShow: '1',
    isPutOn: '0',
    plpTitleLine: 2,
    plpTitleType: 1,
    plpDescriptionLine: 2,
    pdpImgCount: 4,
    shareTitle: 'COCO CRUSH戒指',
    vtoType: '',
    extJson:
      '{"navigationbackpath":"/activities/2025/cococrush/pages/index/index?scene=plp"}',
    view3d: 0,
    createTimestamp: 1720004318818,
    isDeleted: false,
    updateTimestamp: 1732075111914
  },
  {
    id: 797,
    skuId: 'J11191',
    title: 'COCO CRUSH耳环',
    plpTitle: '["COCO CRUSH", "耳环"]',
    pdpTitle: '["COCO CRUSH", "耳环"]',
    description: '菱格纹图案，白18K金与黄18K金，镶嵌钻石',
    plpDescription: '菱格纹图案\n白18K金与黄18K金\n镶嵌钻石',
    pdpDescription: '菱格纹图案，白18K金与黄18K金，镶嵌钻石',
    price: 62200.0,
    localPrice: 0.0,
    isShow: '1',
    isPutOn: '0',
    plpTitleLine: 2,
    plpTitleType: 1,
    plpDescriptionLine: 3,
    pdpImgCount: 3,
    shareTitle: 'COCO CRUSH耳环',
    vtoType: '',
    extJson:
      '{"navigationbackpath":"/activities/2025/cococrush/pages/index/index?scene=plp"}',
    view3d: 0,
    createTimestamp: 1720004317679,
    isDeleted: false,
    updateTimestamp: 1732075111435
  },
  {
    id: 798,
    skuId: 'J11794',
    title: 'COCO CRUSH戒指',
    plpTitle: '["COCO CRUSH", "戒指"]',
    pdpTitle: '["COCO CRUSH", "戒指"]',
    description: '菱格纹图案，精致款，黄18K金',
    plpDescription: '菱格纹图案，精致款\n黄18K金',
    pdpDescription: '菱格纹图案，精致款，黄18K金',
    price: 12900.0,
    localPrice: 0.0,
    isShow: '1',
    isPutOn: '1',
    plpTitleLine: 2,
    plpTitleType: 1,
    plpDescriptionLine: 2,
    pdpImgCount: 4,
    shareTitle: '虚拟试戴COCO CRUSH戒指',
    vtoType: 'RING',
    extJson:
      '{"navigationbackpath":"/activities/2025/cococrush/pages/index/index?scene=plp"}',
    view3d: 0,
    createTimestamp: 1720004316597,
    isDeleted: false,
    updateTimestamp: 1732075110998
  },
  {
    id: 799,
    skuId: 'J12307',
    title: 'Coco Crush项链',
    plpTitle: '["COCO CRUSH", "项链"]',
    pdpTitle: '["COCO CRUSH", "项链"]',
    description: '菱格纹图案，白18K金',
    plpDescription: '菱格纹图案，白18K金',
    pdpDescription: '菱格纹图案，白18K金',
    price: 22800.0,
    localPrice: 0.0,
    isShow: '1',
    isPutOn: '0',
    plpTitleLine: 2,
    plpTitleType: 1,
    plpDescriptionLine: 1,
    pdpImgCount: 4,
    shareTitle: 'COCO CRUSH项链',
    vtoType: '',
    extJson:
      '{"navigationbackpath":"/activities/2025/cococrush/pages/index/index?scene=plp"}',
    view3d: 1,
    createTimestamp: 1720004316051,
    isDeleted: false,
    updateTimestamp: 1732075110374
  },
  {
    id: 800,
    skuId: 'J11903',
    title: 'COCO CRUSH手镯',
    plpTitle: '["COCO CRUSH", "手镯"]',
    pdpTitle: '["COCO CRUSH", "手镯"]',
    description: '菱格纹图案，白18K金，镶嵌钻石',
    plpDescription: '菱格纹图案\n白18K金，镶嵌钻石',
    pdpDescription: '菱格纹图案，白18K金，镶嵌钻石',
    price: 395000.0,
    localPrice: 0.0,
    isShow: '1',
    isPutOn: '0',
    plpTitleLine: 2,
    plpTitleType: 1,
    plpDescriptionLine: 2,
    pdpImgCount: 3,
    shareTitle: 'COCO CRUSH手镯',
    vtoType: '',
    extJson:
      '{"navigationbackpath":"/activities/2025/cococrush/pages/index/index?scene=plp"}',
    view3d: 0,
    createTimestamp: 1720004315012,
    isDeleted: false,
    updateTimestamp: 1732075109883
  },
  {
    id: 801,
    skuId: 'J10571',
    title: 'COCO CRUSH戒指',
    plpTitle: '["COCO CRUSH", "戒指"]',
    pdpTitle: '["COCO CRUSH", "戒指"]',
    description: '菱格纹图案，标准款，黄18K金',
    plpDescription: '菱格纹图案，标准款\n黄18K金',
    pdpDescription: '菱格纹图案，标准款，黄18K金',
    price: 23600.0,
    localPrice: 0.0,
    isShow: '1',
    isPutOn: '1',
    plpTitleLine: 2,
    plpTitleType: 1,
    plpDescriptionLine: 2,
    pdpImgCount: 4,
    shareTitle: '虚拟试戴COCO CRUSH戒指',
    vtoType: 'RING',
    extJson:
      '{"navigationbackpath":"/activities/2025/cococrush/pages/index/index?scene=plp"}',
    view3d: 0,
    createTimestamp: 1720004313927,
    isDeleted: false,
    updateTimestamp: 1732075109460
  },
  {
    id: 802,
    skuId: 'H9763',
    title: 'J12 COUTURE腕表，33毫米',
    plpTitle: '["J12 COUTURE", "腕表", "33", "毫米"]',
    pdpTitle: '["J12 COUTURE", "腕表", "33", "毫米"]',
    description: '白色精密陶瓷和精钢',
    plpDescription: '白色精密陶瓷和精钢',
    pdpDescription: '白色精密陶瓷和精钢',
    price: 59300.0,
    localPrice: 0.0,
    isShow: '1',
    isPutOn: '0',
    plpTitleLine: 2,
    plpTitleType: 2,
    plpDescriptionLine: 1,
    pdpImgCount: 1,
    shareTitle: '虚拟试戴J12腕表',
    vtoType: '',
    extJson:
      '{"navigationbackpath":"/activities/2024/j12/pages/landing/landing?scene=plp"}',
    view3d: 0,
    createTimestamp: 1717659942264,
    isDeleted: false,
    updateTimestamp: 1732075108991
  },
  {
    id: 803,
    skuId: 'H9762',
    title: 'J12 COUTURE腕表，38毫米',
    plpTitle: '["J12 COUTURE", "腕表", "38", "毫米"]',
    pdpTitle: '["J12 COUTURE", "腕表", "38", "毫米"]',
    description: '黑色精密陶瓷和精钢',
    plpDescription: '黑色精密陶瓷和精钢',
    pdpDescription: '黑色精密陶瓷和精钢',
    price: 79600.0,
    localPrice: 0.0,
    isShow: '1',
    isPutOn: '0',
    plpTitleLine: 2,
    plpTitleType: 2,
    plpDescriptionLine: 1,
    pdpImgCount: 1,
    shareTitle: '虚拟试戴J12腕表',
    vtoType: '',
    extJson:
      '{"navigationbackpath":"/activities/2024/j12/pages/landing/landing?scene=plp"}',
    view3d: 0,
    createTimestamp: 1717659924572,
    isDeleted: false,
    updateTimestamp: 1732075108548
  },
  {
    id: 804,
    skuId: 'H9761',
    title: 'MADEMOISELLE J12 COUTURE腕表，38毫米',
    plpTitle: '["MADEMOISELLE", "J12 COUTURE", "腕表", "38", "毫米"]',
    pdpTitle: '["MADEMOISELLE J12 COUTURE", "腕表", "38", "毫米"]',
    description: '黑色精密陶瓷和精钢',
    plpDescription: '黑色精密陶瓷和精钢',
    pdpDescription: '黑色精密陶瓷和精钢',
    price: 130000.0,
    localPrice: 0.0,
    isShow: '1',
    isPutOn: '0',
    plpTitleLine: 3,
    plpTitleType: 4,
    plpDescriptionLine: 1,
    pdpImgCount: 1,
    shareTitle: '虚拟试戴J12腕表',
    vtoType: '',
    extJson:
      '{"navigationbackpath":"/activities/2024/j12/pages/landing/landing?scene=plp"}',
    view3d: 0,
    createTimestamp: 1717659727254,
    isDeleted: false,
    updateTimestamp: 1732075108111
  },
  {
    id: 805,
    skuId: 'J12871',
    title: 'COCO CRUSH戒指',
    plpTitle: '["COCO CRUSH", "戒指"]',
    pdpTitle: '["COCO CRUSH", "戒指"]',
    description: '菱格纹图案，标准款，米色18K金，镶嵌钻石',
    plpDescription: '菱格纹图案，标准款\n米色18K金，镶嵌钻石',
    pdpDescription: '菱格纹图案，标准款，米色18K金，镶嵌钻石',
    price: 85300.0,
    localPrice: 0.0,
    isShow: '1',
    isPutOn: '1',
    plpTitleLine: 2,
    plpTitleType: 1,
    plpDescriptionLine: 2,
    pdpImgCount: 4,
    shareTitle: '虚拟试戴COCO CRUSH戒指',
    vtoType: 'RING',
    extJson:
      '{"navigationbackpath":"/activities/2025/cococrush/pages/index/index?scene=plp"}',
    view3d: 0,
    createTimestamp: 1716964772000,
    isDeleted: false,
    updateTimestamp: 1732075107662
  },
  {
    id: 806,
    skuId: 'J12870',
    title: 'COCO CRUSH戒指',
    plpTitle: '["COCO CRUSH", "戒指"]',
    pdpTitle: '["COCO CRUSH", "戒指"]',
    description: '菱格纹图案，标准款，黄18K金，镶嵌钻石',
    plpDescription: '菱格纹图案，标准款\n黄18K金，镶嵌钻石',
    pdpDescription: '菱格纹图案，标准款，黄18K金，镶嵌钻石',
    price: 83800.0,
    localPrice: 0.0,
    isShow: '1',
    isPutOn: '1',
    plpTitleLine: 2,
    plpTitleType: 1,
    plpDescriptionLine: 2,
    pdpImgCount: 4,
    shareTitle: '虚拟试戴COCO CRUSH戒指',
    vtoType: 'RING',
    extJson:
      '{"navigationbackpath":"/activities/2025/cococrush/pages/index/index?scene=plp"}',
    view3d: 0,
    createTimestamp: 1716964751852,
    isDeleted: false,
    updateTimestamp: 1732075107188
  },
  {
    id: 807,
    skuId: 'J12869',
    title: 'COCO CRUSH戒指',
    plpTitle: '["COCO CRUSH", "戒指"]',
    pdpTitle: '["COCO CRUSH", "戒指"]',
    description: '菱格纹图案，标准款，白18K金，镶嵌钻石',
    plpDescription: '菱格纹图案，标准款\n白18K金，镶嵌钻石',
    pdpDescription: '菱格纹图案，标准款，白18K金，镶嵌钻石',
    price: 89500.0,
    localPrice: 0.0,
    isShow: '1',
    isPutOn: '1',
    plpTitleLine: 2,
    plpTitleType: 1,
    plpDescriptionLine: 2,
    pdpImgCount: 4,
    shareTitle: '虚拟试戴COCO CRUSH戒指',
    vtoType: 'RING',
    extJson:
      '{"navigationbackpath":"/activities/2025/cococrush/pages/index/index?scene=plp"}',
    view3d: 0,
    createTimestamp: 1716964736164,
    isDeleted: false,
    updateTimestamp: 1732075106541
  },
  {
    id: 808,
    skuId: 'J12915',
    title: 'COCO CRUSH单只耳环',
    plpTitle: '["COCO CRUSH", "单只耳环"]',
    pdpTitle: '["COCO CRUSH", "单只耳环"]',
    description: '菱格纹图案，白18K金与米色18K金，镶嵌钻石',
    plpDescription: '菱格纹图案\n白18K金与米色18K金\n镶嵌钻石',
    pdpDescription: '菱格纹图案，白18K金与米色18K金，镶嵌钻石',
    price: 28500.0,
    localPrice: 0.0,
    isShow: '1',
    isPutOn: '0',
    plpTitleLine: 2,
    plpTitleType: 1,
    plpDescriptionLine: 3,
    pdpImgCount: 3,
    shareTitle: 'COCO CRUSH单只耳环',
    vtoType: '',
    extJson: '{"navigationbackpath":"/pages/loading/loading"}',
    view3d: 0,
    createTimestamp: 1716964724161,
    isDeleted: false,
    updateTimestamp: 1732075106064
  },
  {
    id: 809,
    skuId: 'J12687',
    title: 'COCO CRUSH单只耳环',
    plpTitle: '["COCO CRUSH", "单只耳环"]',
    pdpTitle: '["COCO CRUSH", "单只耳环"]',
    description: '菱格纹图案，白18K金',
    plpDescription: '菱格纹图案，白18K金',
    pdpDescription: '菱格纹图案，白18K金',
    price: 14800.0,
    localPrice: 0.0,
    isShow: '1',
    isPutOn: '1',
    plpTitleLine: 2,
    plpTitleType: 1,
    plpDescriptionLine: 1,
    pdpImgCount: 3,
    shareTitle: '虚拟试戴COCO CRUSH单只耳环',
    vtoType: 'EARRINGS',
    extJson:
      '{"navigationbackpath":"/activities/2025/cococrush/pages/index/index?scene=plp"}',
    view3d: 0,
    createTimestamp: 1716964702207,
    isDeleted: false,
    updateTimestamp: 1732075105548
  },
  {
    id: 810,
    skuId: 'J12686',
    title: 'COCO CRUSH单只耳环',
    plpTitle: '["COCO CRUSH", "单只耳环"]',
    pdpTitle: '["COCO CRUSH", "单只耳环"]',
    description: '菱格纹图案，米色18K金',
    plpDescription: '菱格纹图案，米色18K金',
    pdpDescription: '菱格纹图案，米色18K金',
    price: 14100.0,
    localPrice: 0.0,
    isShow: '1',
    isPutOn: '1',
    plpTitleLine: 2,
    plpTitleType: 1,
    plpDescriptionLine: 1,
    pdpImgCount: 3,
    shareTitle: '虚拟试戴COCO CRUSH单只耳环',
    vtoType: 'EARRINGS',
    extJson:
      '{"navigationbackpath":"/activities/2025/cococrush/pages/index/index?scene=plp"}',
    view3d: 0,
    createTimestamp: 1716964683183,
    isDeleted: false,
    updateTimestamp: 1732075105011
  },
  {
    id: 811,
    skuId: 'J12685',
    title: 'COCO CRUSH单只耳环',
    plpTitle: '["COCO CRUSH", "单只耳环"]',
    pdpTitle: '["COCO CRUSH", "单只耳环"]',
    description: '菱格纹图案，黄18K金',
    plpDescription: '菱格纹图案，黄18K金',
    pdpDescription: '菱格纹图案，黄18K金',
    price: 13800.0,
    localPrice: 0.0,
    isShow: '1',
    isPutOn: '1',
    plpTitleLine: 2,
    plpTitleType: 1,
    plpDescriptionLine: 1,
    pdpImgCount: 3,
    shareTitle: '虚拟试戴COCO CRUSH单只耳环',
    vtoType: 'EARRINGS',
    extJson:
      '{"navigationbackpath":"/activities/2025/cococrush/pages/index/index?scene=plp"}',
    view3d: 0,
    createTimestamp: 1716964637288,
    isDeleted: false,
    updateTimestamp: 1732075104490
  },
  {
    id: 812,
    skuId: 'J12906',
    title: 'Extrait de N°5手链',
    plpTitle: '["Extrait de N°5", "手链"]',
    pdpTitle: '["Extrait de N°5", "手链"]',
    description: '黄18K金，镶嵌钻石',
    plpDescription: '黄18K金，镶嵌钻石',
    pdpDescription: '黄18K金，镶嵌钻石',
    price: 28500.0,
    localPrice: 0.0,
    isShow: '1',
    isPutOn: '0',
    plpTitleLine: 2,
    plpTitleType: 1,
    plpDescriptionLine: 1,
    pdpImgCount: 2,
    shareTitle: 'EXTRAIT DE N°5手链',
    vtoType: '',
    extJson:
      '{"navigationbackpath":"/activities/2024/pjn5/pages/index/index?scene=plp"}',
    view3d: 0,
    createTimestamp: 1715075173573,
    isDeleted: false,
    updateTimestamp: 1732075104017
  },
  {
    id: 813,
    skuId: 'J12905',
    title: 'Extrait de N°5戒指',
    plpTitle: '["Extrait de N°5", "戒指"]',
    pdpTitle: '["Extrait de N°5", "戒指"]',
    description: '黄18K金，镶嵌钻石',
    plpDescription: '黄18K金，镶嵌钻石',
    pdpDescription: '黄18K金，镶嵌钻石',
    price: 33800.0,
    localPrice: 0.0,
    isShow: '1',
    isPutOn: '0',
    plpTitleLine: 2,
    plpTitleType: 1,
    plpDescriptionLine: 1,
    pdpImgCount: 2,
    shareTitle: 'EXTRAIT DE N°5戒指',
    vtoType: '',
    extJson:
      '{"navigationbackpath":"/activities/2024/pjn5/pages/index/index?scene=plp"}',
    view3d: 0,
    createTimestamp: 1715075172835,
    isDeleted: false,
    updateTimestamp: 1732075103574
  },
  {
    id: 814,
    skuId: 'J12904',
    title: 'Extrait de N°5项链',
    plpTitle: '["Extrait de N°5", "项链"]',
    pdpTitle: '["Extrait de N°5", "项链"]',
    description: '黄18K金，镶嵌钻石',
    plpDescription: '黄18K金，镶嵌钻石',
    pdpDescription: '黄18K金，镶嵌钻石',
    price: 30900.0,
    localPrice: 0.0,
    isShow: '1',
    isPutOn: '0',
    plpTitleLine: 2,
    plpTitleType: 1,
    plpDescriptionLine: 1,
    pdpImgCount: 5,
    shareTitle: 'EXTRAIT DE N°5项链',
    vtoType: '',
    extJson:
      '{"navigationbackpath":"/activities/2024/pjn5/pages/index/index?scene=plp"}',
    view3d: 0,
    createTimestamp: 1715075172043,
    isDeleted: false,
    updateTimestamp: 1732075103089
  },
  {
    id: 815,
    skuId: 'J12903',
    title: 'Eternal N°5耳环，可变换佩戴方式',
    plpTitle: '["Eternal N°5", "耳环"]',
    pdpTitle: '["Eternal N°5", "耳环"]',
    description: '米色18K金，镶嵌钻石',
    plpDescription: '米色18K金，镶嵌钻石\n可变换佩戴方式',
    pdpDescription: '米色18K金，镶嵌钻石\n可变换佩戴方式',
    price: 272300.0,
    localPrice: 0.0,
    isShow: '1',
    isPutOn: '0',
    plpTitleLine: 2,
    plpTitleType: 1,
    plpDescriptionLine: 2,
    pdpImgCount: 4,
    shareTitle: 'ETERNAL N°5耳环',
    vtoType: '',
    extJson:
      '{"navigationbackpath":"/activities/2024/pjn5/pages/index/index?scene=plp"}',
    view3d: 0,
    createTimestamp: 1715075164730,
    isDeleted: false,
    updateTimestamp: 1732075102648
  },
  {
    id: 816,
    skuId: 'J12902',
    title: 'Eternal N°5项链',
    plpTitle: '["Eternal N°5", "项链"]',
    pdpTitle: '["Eternal N°5", "项链"]',
    description: '米色18K金，镶嵌钻石',
    plpDescription: '米色18K金，镶嵌钻石',
    pdpDescription: '米色18K金，镶嵌钻石',
    price: 421000.0,
    localPrice: 0.0,
    isShow: '1',
    isPutOn: '0',
    plpTitleLine: 2,
    plpTitleType: 1,
    plpDescriptionLine: 1,
    pdpImgCount: 4,
    shareTitle: 'ETERNAL N°5项链',
    vtoType: '',
    extJson:
      '{"navigationbackpath":"/activities/2024/pjn5/pages/index/index?scene=plp"}',
    view3d: 0,
    createTimestamp: 1715075163935,
    isDeleted: false,
    updateTimestamp: 1732075102227
  },
  {
    id: 817,
    skuId: 'J12816',
    title: 'Eternal N°5手镯',
    plpTitle: '["Eternal N°5", "手镯"]',
    pdpTitle: '["Eternal N°5", "手镯"]',
    description: '白18K金，镶嵌钻石',
    plpDescription: '白18K金，镶嵌钻石',
    pdpDescription: '白18K金，镶嵌钻石',
    price: 90200.0,
    localPrice: 0.0,
    isShow: '1',
    isPutOn: '0',
    plpTitleLine: 2,
    plpTitleType: 1,
    plpDescriptionLine: 1,
    pdpImgCount: 3,
    shareTitle: 'ETERNAL N°5手镯',
    vtoType: '',
    extJson:
      '{"navigationbackpath":"/activities/2024/pjn5/pages/index/index?scene=plp"}',
    view3d: 0,
    createTimestamp: 1715075163127,
    isDeleted: false,
    updateTimestamp: 1732075101788
  },
  {
    id: 818,
    skuId: 'J12812',
    title: 'Eternal N°5手镯',
    plpTitle: '["Eternal N°5", "手镯"]',
    pdpTitle: '["Eternal N°5", "手镯"]',
    description: '米色18K金，镶嵌钻石',
    plpDescription: '米色18K金，镶嵌钻石',
    pdpDescription: '米色18K金，镶嵌钻石',
    price: 85300.0,
    localPrice: 0.0,
    isShow: '1',
    isPutOn: '0',
    plpTitleLine: 2,
    plpTitleType: 1,
    plpDescriptionLine: 1,
    pdpImgCount: 3,
    shareTitle: 'ETERNAL N°5手镯',
    vtoType: '',
    extJson:
      '{"navigationbackpath":"/activities/2024/pjn5/pages/index/index?scene=plp"}',
    view3d: 0,
    createTimestamp: 1715075161871,
    isDeleted: false,
    updateTimestamp: 1732075101251
  },
  {
    id: 819,
    skuId: 'J12194',
    title: 'Eternal N°5耳环，可变换佩戴方式',
    plpTitle: '["Eternal N°5", "耳环"]',
    pdpTitle: '["Eternal N°5", "耳环"]',
    description: '米色18K金，镶嵌钻石',
    plpDescription: '米色18K金，镶嵌钻石\n可变换佩戴方式',
    pdpDescription: '米色18K金，镶嵌钻石\n可变换佩戴方式',
    price: 98300.0,
    localPrice: 0.0,
    isShow: '1',
    isPutOn: '0',
    plpTitleLine: 2,
    plpTitleType: 1,
    plpDescriptionLine: 2,
    pdpImgCount: 6,
    shareTitle: 'ETERNAL N°5耳环',
    vtoType: '',
    extJson:
      '{"navigationbackpath":"/activities/2024/pjn5/pages/index/index?scene=plp"}',
    view3d: 1,
    createTimestamp: 1715075161096,
    isDeleted: false,
    updateTimestamp: 1732075100762
  },
  {
    id: 820,
    skuId: 'J11998',
    title: 'Eternal N°5项链',
    plpTitle: '["Eternal N°5", "项链"]',
    pdpTitle: '["Eternal N°5", "项链"]',
    description: '白18K金，镶嵌钻石',
    plpDescription: '白18K金，镶嵌钻石',
    pdpDescription: '白18K金，镶嵌钻石',
    price: 443800.0,
    localPrice: 0.0,
    isShow: '1',
    isPutOn: '0',
    plpTitleLine: 2,
    plpTitleType: 1,
    plpDescriptionLine: 1,
    pdpImgCount: 4,
    shareTitle: 'ETERNAL N°5项链',
    vtoType: '',
    extJson:
      '{"navigationbackpath":"/activities/2024/pjn5/pages/index/index?scene=plp"}',
    view3d: 1,
    createTimestamp: 1715075159858,
    isDeleted: false,
    updateTimestamp: 1732075100219
  },
  {
    id: 821,
    skuId: 'J11992',
    title: 'Eternal N°5耳环，可变换佩戴方式',
    plpTitle: '["Eternal N°5", "耳环"]',
    pdpTitle: '["Eternal N°5", "耳环"]',
    description: '白18K金，镶嵌钻石',
    plpDescription: '白18K金，镶嵌钻石\n可变换佩戴方式',
    pdpDescription: '白18K金，镶嵌钻石\n可变换佩戴方式',
    price: 103200.0,
    localPrice: 0.0,
    isShow: '1',
    isPutOn: '0',
    plpTitleLine: 2,
    plpTitleType: 1,
    plpDescriptionLine: 2,
    pdpImgCount: 6,
    shareTitle: 'ETERNAL N°5耳环',
    vtoType: '',
    extJson:
      '{"navigationbackpath":"/activities/2024/pjn5/pages/index/index?scene=plp"}',
    view3d: 1,
    createTimestamp: 1715075158435,
    isDeleted: false,
    updateTimestamp: 1732075099785
  },
  {
    id: 822,
    skuId: 'J12193',
    title: 'Eternal N°5项链',
    plpTitle: '["Eternal N°5", "项链"]',
    pdpTitle: '["Eternal N°5", "项链"]',
    description: '米色18K金，镶嵌钻石',
    plpDescription: '米色18K金，镶嵌钻石',
    pdpDescription: '米色18K金，镶嵌钻石',
    price: 78000.0,
    localPrice: 0.0,
    isShow: '1',
    isPutOn: '0',
    plpTitleLine: 2,
    plpTitleType: 1,
    plpDescriptionLine: 1,
    pdpImgCount: 4,
    shareTitle: 'ETERNAL N°5项链',
    vtoType: '',
    extJson:
      '{"navigationbackpath":"/activities/2024/pjn5/pages/index/index?scene=plp"}',
    view3d: 1,
    createTimestamp: 1715075157706,
    isDeleted: false,
    updateTimestamp: 1732075099329
  },
  {
    id: 823,
    skuId: 'J12191',
    title: 'Eternal N°5单只耳环',
    plpTitle: '["Eternal N°5", "单只耳环"]',
    pdpTitle: '["Eternal N°5", "单只耳环"]',
    description: '米色18K金，镶嵌钻石',
    plpDescription: '米色18K金，镶嵌钻石',
    pdpDescription: '米色18K金，镶嵌钻石',
    price: 35500.0,
    localPrice: 0.0,
    isShow: '1',
    isPutOn: '0',
    plpTitleLine: 2,
    plpTitleType: 1,
    plpDescriptionLine: 1,
    pdpImgCount: 3,
    shareTitle: 'ETERNAL N°5单只耳环',
    vtoType: '',
    extJson:
      '{"navigationbackpath":"/activities/2024/pjn5/pages/index/index?scene=plp"}',
    view3d: 1,
    createTimestamp: 1715075156903,
    isDeleted: false,
    updateTimestamp: 1732075098873
  },
  {
    id: 824,
    skuId: 'J12200',
    title: 'Eternal N°5单只耳环',
    plpTitle: '["Eternal N°5", "单只耳环"]',
    pdpTitle: '["Eternal N°5", "单只耳环"]',
    description: '白18K金，镶嵌钻石',
    plpDescription: '白18K金，镶嵌钻石',
    pdpDescription: '白18K金，镶嵌钻石',
    price: 37100.0,
    localPrice: 0.0,
    isShow: '1',
    isPutOn: '0',
    plpTitleLine: 2,
    plpTitleType: 1,
    plpDescriptionLine: 1,
    pdpImgCount: 3,
    shareTitle: 'ETERNAL N°5单只耳环',
    vtoType: '',
    extJson:
      '{"navigationbackpath":"/activities/2024/pjn5/pages/index/index?scene=plp"}',
    view3d: 1,
    createTimestamp: 1715075155755,
    isDeleted: false,
    updateTimestamp: 1732075098371
  },
  {
    id: 825,
    skuId: 'J12002',
    title: 'Eternal N°5戒指',
    plpTitle: '["Eternal N°5", "戒指"]',
    pdpTitle: '["Eternal N°5", "戒指"]',
    description: '白18K金，镶嵌钻石',
    plpDescription: '白18K金，镶嵌钻石',
    pdpDescription: '白18K金，镶嵌钻石',
    price: 77200.0,
    localPrice: 0.0,
    isShow: '1',
    isPutOn: '1',
    plpTitleLine: 2,
    plpTitleType: 1,
    plpDescriptionLine: 1,
    pdpImgCount: 2,
    shareTitle: '虚拟试戴ETERNAL N°5戒指',
    vtoType: 'RING',
    extJson:
      '{"navigationbackpath":"/activities/2024/pjn5/pages/index/index?scene=plp"}',
    view3d: 1,
    createTimestamp: 1715075154465,
    isDeleted: false,
    updateTimestamp: 1732075097682
  },
  {
    id: 826,
    skuId: 'J11991',
    title: 'Eternal N°5项链',
    plpTitle: '["Eternal N°5", "项链"]',
    pdpTitle: '["Eternal N°5", "项链"]',
    description: '白18K金，镶嵌钻石',
    plpDescription: '白18K金，镶嵌钻石',
    pdpDescription: '白18K金，镶嵌钻石',
    price: 79600.0,
    localPrice: 0.0,
    isShow: '1',
    isPutOn: '0',
    plpTitleLine: 2,
    plpTitleType: 1,
    plpDescriptionLine: 1,
    pdpImgCount: 4,
    shareTitle: 'ETERNAL N°5项链',
    vtoType: '',
    extJson:
      '{"navigationbackpath":"/activities/2024/pjn5/pages/index/index?scene=plp"}',
    view3d: 1,
    createTimestamp: 1715075152937,
    isDeleted: false,
    updateTimestamp: 1732075097098
  },
  {
    id: 827,
    skuId: 'J12187',
    title: 'Eternal N°5戒指',
    plpTitle: '["Eternal N°5", "戒指"]',
    pdpTitle: '["Eternal N°5", "戒指"]',
    description: '米色18K金，镶嵌钻石',
    plpDescription: '米色18K金，镶嵌钻石',
    pdpDescription: '米色18K金，镶嵌钻石',
    price: 73500.0,
    localPrice: 0.0,
    isShow: '1',
    isPutOn: '0',
    plpTitleLine: 2,
    plpTitleType: 1,
    plpDescriptionLine: 1,
    pdpImgCount: 2,
    shareTitle: 'ETERNAL N°5戒指',
    vtoType: '',
    extJson:
      '{"navigationbackpath":"/activities/2024/pjn5/pages/index/index?scene=plp"}',
    view3d: 1,
    createTimestamp: 1715075152176,
    isDeleted: false,
    updateTimestamp: 1732075096656
  },
  {
    id: 828,
    skuId: 'J12417',
    title: 'Eternal N°5耳环，可变换佩戴方式',
    plpTitle: '["Eternal N°5", "耳环"]',
    pdpTitle: '["Eternal N°5", "耳环"]',
    description: '白18K金，镶嵌钻石',
    plpDescription: '白18K金，镶嵌钻石\n可变换佩戴方式',
    pdpDescription: '白18K金，镶嵌钻石\n可变换佩戴方式',
    price: 286900.0,
    localPrice: 0.0,
    isShow: '1',
    isPutOn: '0',
    plpTitleLine: 2,
    plpTitleType: 1,
    plpDescriptionLine: 2,
    pdpImgCount: 4,
    shareTitle: 'ETERNAL N°5耳环',
    vtoType: '',
    extJson:
      '{"navigationbackpath":"/activities/2024/pjn5/pages/index/index?scene=plp"}',
    view3d: 1,
    createTimestamp: 1715075151427,
    isDeleted: false,
    updateTimestamp: 1732075095434
  },
  {
    id: 829,
    skuId: 'J12407',
    title: 'Eternal N°5戒指',
    plpTitle: '["Eternal N°5", "戒指"]',
    pdpTitle: '["Eternal N°5", "戒指"]',
    description: '米色18K金，镶嵌钻石',
    plpDescription: '米色18K金，镶嵌钻石',
    pdpDescription: '米色18K金，镶嵌钻石',
    price: 126800.0,
    localPrice: 0.0,
    isShow: '1',
    isPutOn: '0',
    plpTitleLine: 2,
    plpTitleType: 1,
    plpDescriptionLine: 1,
    pdpImgCount: 2,
    shareTitle: 'ETERNAL N°5戒指',
    vtoType: '',
    extJson:
      '{"navigationbackpath":"/activities/2024/pjn5/pages/index/index?scene=plp"}',
    view3d: 1,
    createTimestamp: 1715075150511,
    isDeleted: false,
    updateTimestamp: 1732075094560
  },
  {
    id: 830,
    skuId: 'J12405',
    title: 'Eternal N°5戒指',
    plpTitle: '["Eternal N°5", "戒指"]',
    pdpTitle: '["Eternal N°5", "戒指"]',
    description: '白18K金，镶嵌钻石',
    plpDescription: '白18K金，镶嵌钻石',
    pdpDescription: '白18K金，镶嵌钻石',
    price: 133300.0,
    localPrice: 0.0,
    isShow: '1',
    isPutOn: '0',
    plpTitleLine: 2,
    plpTitleType: 1,
    plpDescriptionLine: 1,
    pdpImgCount: 2,
    shareTitle: 'ETERNAL N°5戒指',
    vtoType: '',
    extJson:
      '{"navigationbackpath":"/activities/2024/pjn5/pages/index/index?scene=plp"}',
    view3d: 1,
    createTimestamp: 1715075149671,
    isDeleted: false,
    updateTimestamp: 1732075094094
  },
  {
    id: 831,
    skuId: 'J12429',
    title: 'Extrait de N°5项链',
    plpTitle: '["Extrait de N°5", "项链"]',
    pdpTitle: '["Extrait de N°5", "项链"]',
    description: '米色18K金，镶嵌钻石',
    plpDescription: '米色18K金，镶嵌钻石',
    pdpDescription: '米色18K金，镶嵌钻石',
    price: 31300.0,
    localPrice: 0.0,
    isShow: '1',
    isPutOn: '0',
    plpTitleLine: 2,
    plpTitleType: 1,
    plpDescriptionLine: 1,
    pdpImgCount: 5,
    shareTitle: 'EXTRAIT DE N°5项链',
    vtoType: '',
    extJson:
      '{"navigationbackpath":"/activities/2024/pjn5/pages/index/index?scene=plp"}',
    view3d: 1,
    createTimestamp: 1715075148985,
    isDeleted: false,
    updateTimestamp: 1732075093628
  },
  {
    id: 832,
    skuId: 'J12400',
    title: 'Extrait de N°5戒指',
    plpTitle: '["Extrait de N°5", "戒指"]',
    pdpTitle: '["Extrait de N°5", "戒指"]',
    description: '米色18K金，镶嵌钻石',
    plpDescription: '米色18K金，镶嵌钻石',
    pdpDescription: '米色18K金，镶嵌钻石',
    price: 34100.0,
    localPrice: 0.0,
    isShow: '1',
    isPutOn: '0',
    plpTitleLine: 2,
    plpTitleType: 1,
    plpDescriptionLine: 1,
    pdpImgCount: 2,
    shareTitle: 'EXTRAIT DE N°5戒指',
    vtoType: '',
    extJson:
      '{"navigationbackpath":"/activities/2024/pjn5/pages/index/index?scene=plp"}',
    view3d: 1,
    createTimestamp: 1715075148034,
    isDeleted: false,
    updateTimestamp: 1732075092970
  },
  {
    id: 833,
    skuId: 'J12428',
    title: 'Extrait de N°5手链',
    plpTitle: '["Extrait de N°5", "手链"]',
    pdpTitle: '["Extrait de N°5", "手链"]',
    description: '米色18K金，镶嵌钻石',
    plpDescription: '米色18K金，镶嵌钻石',
    pdpDescription: '米色18K金，镶嵌钻石',
    price: 28900.0,
    localPrice: 0.0,
    isShow: '1',
    isPutOn: '0',
    plpTitleLine: 2,
    plpTitleType: 1,
    plpDescriptionLine: 1,
    pdpImgCount: 2,
    shareTitle: 'EXTRAIT DE N°5手链',
    vtoType: '',
    extJson:
      '{"navigationbackpath":"/activities/2024/pjn5/pages/index/index?scene=plp"}',
    view3d: 0,
    createTimestamp: 1715075147236,
    isDeleted: false,
    updateTimestamp: 1732075092405
  },
  {
    id: 834,
    skuId: 'J10818',
    title: 'COCO CRUSH戒指',
    plpTitle: '["COCO CRUSH", "戒指"]',
    pdpTitle: '["COCO CRUSH", "戒指"]',
    description: '菱格纹图案，奢华款，米色18K金',
    plpDescription: '菱格纹图案，奢华款\n米色18K金',
    pdpDescription: '菱格纹图案，奢华款，米色18K金',
    price: 33300.0,
    localPrice: 0.0,
    isShow: '1',
    isPutOn: '1',
    plpTitleLine: 2,
    plpTitleType: 1,
    plpDescriptionLine: 2,
    pdpImgCount: 4,
    shareTitle: '虚拟试戴COCO CRUSH戒指',
    vtoType: 'RING',
    extJson:
      '{"navigationbackpath":"/activities/2025/cococrush/pages/index/index?scene=plp"}',
    view3d: 0,
    createTimestamp: 1715075146456,
    isDeleted: false,
    updateTimestamp: 1732075091836
  },
  {
    id: 835,
    skuId: 'J12368',
    title: 'COCO手链',
    plpTitle: '["COCO", "手链"]',
    pdpTitle: '["COCO", "手链"]',
    description: '菱格纹图案，米色18K金，镶嵌钻石',
    plpDescription: '菱格纹图案，米色18K金\n镶嵌钻石',
    pdpDescription: '菱格纹图案，米色18K金，镶嵌钻石',
    price: 19000.0,
    localPrice: 0.0,
    isShow: '1',
    isPutOn: '0',
    plpTitleLine: 2,
    plpTitleType: 1,
    plpDescriptionLine: 2,
    pdpImgCount: 2,
    shareTitle: 'COCO手链',
    vtoType: '',
    extJson:
      '{"navigationbackpath":"/activities/2025/cococrush/pages/index/index?scene=plp"}',
    view3d: 1,
    createTimestamp: 1715075145711,
    isDeleted: false,
    updateTimestamp: 1732075091356
  },
  {
    id: 836,
    skuId: 'J11101',
    title: 'COCO CRUSH戒指',
    plpTitle: '["COCO CRUSH", "戒指"]',
    pdpTitle: '["COCO CRUSH", "戒指"]',
    description: '菱格纹图案，标准款，米色18K金，镶嵌钻石',
    plpDescription: '菱格纹图案，标准款\n米色18K金，镶嵌钻石',
    pdpDescription: '菱格纹图案，标准款，米色18K金，镶嵌钻石',
    price: 44300.0,
    localPrice: 0.0,
    isShow: '1',
    isPutOn: '0',
    plpTitleLine: 2,
    plpTitleType: 1,
    plpDescriptionLine: 2,
    pdpImgCount: 4,
    shareTitle: 'COCO CRUSH戒指',
    vtoType: '',
    extJson:
      '{"navigationbackpath":"/activities/2025/cococrush/pages/index/index?scene=plp"}',
    view3d: 0,
    createTimestamp: 1715075144298,
    isDeleted: false,
    updateTimestamp: 1732075090919
  },
  {
    id: 837,
    skuId: 'J12497',
    title: 'COCO CRUSH耳环',
    plpTitle: '["COCO CRUSH", "耳环"]',
    pdpTitle: '["COCO CRUSH", "耳环"]',
    description: '菱格纹图案，白18K金，镶嵌钻石',
    plpDescription: '菱格纹图案\n白18K金，镶嵌钻石',
    pdpDescription: '菱格纹图案，白18K金，镶嵌钻石',
    price: 54900.0,
    localPrice: 0.0,
    isShow: '1',
    isPutOn: '0',
    plpTitleLine: 2,
    plpTitleType: 1,
    plpDescriptionLine: 2,
    pdpImgCount: 3,
    shareTitle: 'COCO CRUSH耳环',
    vtoType: '',
    extJson:
      '{"navigationbackpath":"/activities/2025/cococrush/pages/index/index?scene=plp"}',
    view3d: 0,
    createTimestamp: 1715075143511,
    isDeleted: false,
    updateTimestamp: 1732075090425
  },
  {
    id: 838,
    skuId: 'J11754',
    title: 'COCO CRUSH耳环',
    plpTitle: '["COCO CRUSH", "耳环"]',
    pdpTitle: '["COCO CRUSH", "耳环"]',
    description: '菱格纹图案，米色18K金',
    plpDescription: '菱格纹图案，米色18K金',
    pdpDescription: '菱格纹图案，米色18K金',
    price: 33500.0,
    localPrice: 0.0,
    isShow: '1',
    isPutOn: '1',
    plpTitleLine: 2,
    plpTitleType: 1,
    plpDescriptionLine: 1,
    pdpImgCount: 3,
    shareTitle: '虚拟试戴COCO CRUSH耳环',
    vtoType: 'EARRINGS',
    extJson:
      '{"navigationbackpath":"/activities/2025/cococrush/pages/index/index?scene=plp"}',
    view3d: 0,
    createTimestamp: 1715075142748,
    isDeleted: false,
    updateTimestamp: 1732075089923
  },
  {
    id: 839,
    skuId: 'J12154',
    title: 'COCO CRUSH单只耳环',
    plpTitle: '["COCO CRUSH", "单只耳环"]',
    pdpTitle: '["COCO CRUSH", "单只耳环"]',
    description: '菱格纹图案，白18K金，镶嵌钻石',
    plpDescription: '菱格纹图案，白18K金\n镶嵌钻石',
    pdpDescription: '菱格纹图案，白18K金，镶嵌钻石',
    price: 19000.0,
    localPrice: 0.0,
    isShow: '1',
    isPutOn: '0',
    plpTitleLine: 2,
    plpTitleType: 1,
    plpDescriptionLine: 2,
    pdpImgCount: 3,
    shareTitle: 'COCO CRUSH单只耳环',
    vtoType: '',
    extJson:
      '{"navigationbackpath":"/activities/2025/cococrush/pages/index/index?scene=plp"}',
    view3d: 1,
    createTimestamp: 1715075142015,
    isDeleted: false,
    updateTimestamp: 1732075089487
  },
  {
    id: 840,
    skuId: 'J11786',
    title: 'COCO CRUSH戒指',
    plpTitle: '["COCO CRUSH", "戒指"]',
    pdpTitle: '["COCO CRUSH", "戒指"]',
    description: '菱格纹图案，精致款，米色18K金，镶嵌钻石',
    plpDescription: '菱格纹图案，精致款\n米色18K金，镶嵌钻石',
    pdpDescription: '菱格纹图案，精致款，米色18K金，镶嵌钻石',
    price: 34800.0,
    localPrice: 0.0,
    isShow: '1',
    isPutOn: '1',
    plpTitleLine: 2,
    plpTitleType: 1,
    plpDescriptionLine: 2,
    pdpImgCount: 4,
    shareTitle: '虚拟试戴COCO CRUSH戒指',
    vtoType: 'RING',
    extJson:
      '{"navigationbackpath":"/activities/2025/cococrush/pages/index/index?scene=plp"}',
    view3d: 1,
    createTimestamp: 1715075141157,
    isDeleted: false,
    updateTimestamp: 1732075089031
  },
  {
    id: 841,
    skuId: 'J11793',
    title: 'COCO CRUSH戒指',
    plpTitle: '["COCO CRUSH", "戒指"]',
    pdpTitle: '["COCO CRUSH", "戒指"]',
    description: '菱格纹图案，精致款，白18K金',
    plpDescription: '菱格纹图案，精致款\n白18K金',
    pdpDescription: '菱格纹图案，精致款，白18K金',
    price: 13800.0,
    localPrice: 0.0,
    isShow: '1',
    isPutOn: '1',
    plpTitleLine: 2,
    plpTitleType: 1,
    plpDescriptionLine: 2,
    pdpImgCount: 4,
    shareTitle: '虚拟试戴COCO CRUSH戒指',
    vtoType: 'RING',
    extJson:
      '{"navigationbackpath":"/activities/2025/cococrush/pages/index/index?scene=plp"}',
    view3d: 0,
    createTimestamp: 1715075139479,
    isDeleted: false,
    updateTimestamp: 1732075088552
  },
  {
    id: 842,
    skuId: 'J12102',
    title: 'COCO项链',
    plpTitle: '["COCO", "项链"]',
    pdpTitle: '["COCO", "项链"]',
    description: '菱格纹图案，米色18K金，镶嵌钻石',
    plpDescription: '菱格纹图案，米色18K金\n镶嵌钻石',
    pdpDescription: '菱格纹图案，米色18K金，镶嵌钻石',
    price: 48800.0,
    localPrice: 0.0,
    isShow: '1',
    isPutOn: '0',
    plpTitleLine: 2,
    plpTitleType: 1,
    plpDescriptionLine: 2,
    pdpImgCount: 4,
    shareTitle: 'COCO项链',
    vtoType: '',
    extJson:
      '{"navigationbackpath":"/activities/2025/cococrush/pages/index/index?scene=plp"}',
    view3d: 1,
    createTimestamp: 1715075138780,
    isDeleted: false,
    updateTimestamp: 1732075088060
  },
  {
    id: 843,
    skuId: 'J11333',
    title: 'COCO CRUSH手镯',
    plpTitle: '["COCO CRUSH", "手镯"]',
    pdpTitle: '["COCO CRUSH", "手镯"]',
    description: '菱格纹图案，米色18K金',
    plpDescription: '菱格纹图案，米色18K金',
    pdpDescription: '菱格纹图案，米色18K金',
    price: 69900.0,
    localPrice: 0.0,
    isShow: '1',
    isPutOn: '1',
    plpTitleLine: 2,
    plpTitleType: 1,
    plpDescriptionLine: 1,
    pdpImgCount: 3,
    shareTitle: '虚拟试戴COCO CRUSH手镯',
    vtoType: 'BRACELET',
    extJson:
      '{"navigationbackpath":"/activities/2025/cococrush/pages/index/index?scene=plp"}',
    view3d: 0,
    createTimestamp: 1715075137918,
    isDeleted: false,
    updateTimestamp: 1732075087616
  },
  {
    id: 844,
    skuId: 'J12149',
    title: 'COCO CRUSH单只耳环',
    plpTitle: '["COCO CRUSH", "单只耳环"]',
    pdpTitle: '["COCO CRUSH", "单只耳环"]',
    description: '菱格纹图案，米色18K金',
    plpDescription: '菱格纹图案，米色18K金',
    pdpDescription: '菱格纹图案，米色18K金',
    price: 11500.0,
    localPrice: 0.0,
    isShow: '1',
    isPutOn: '1',
    plpTitleLine: 2,
    plpTitleType: 1,
    plpDescriptionLine: 1,
    pdpImgCount: 3,
    shareTitle: '虚拟试戴COCO CRUSH单只耳环',
    vtoType: 'EARRINGS',
    extJson:
      '{"navigationbackpath":"/activities/2025/cococrush/pages/index/index?scene=plp"}',
    view3d: 0,
    createTimestamp: 1715075136689,
    isDeleted: false,
    updateTimestamp: 1732075087084
  },
  {
    id: 845,
    skuId: 'J11971',
    title: 'COCO CRUSH Toi et Moi戒指',
    plpTitle: '["COCO CRUSH", "TOI ET MOI", "戒指"]',
    pdpTitle: '["COCO CRUSH TOI ET MOI", "戒指"]',
    description: '菱格纹图案，标准款，白18K金与米色18K金，镶嵌钻石',
    plpDescription: '菱格纹图案，标准款，白18K\n金与米色18K金，镶嵌钻石',
    pdpDescription: '菱格纹图案，标准款\n白18K金与米色18K金，镶嵌钻石',
    price: 30100.0,
    localPrice: 0.0,
    isShow: '1',
    isPutOn: '1',
    plpTitleLine: 2,
    plpTitleType: 3,
    plpDescriptionLine: 2,
    pdpImgCount: 2,
    shareTitle: '虚拟试戴COCO CRUSH TOI ET MOI戒指',
    vtoType: 'RING',
    extJson:
      '{"navigationbackpath":"/activities/2025/cococrush/pages/index/index?scene=plp"}',
    view3d: 1,
    createTimestamp: 1715075135977,
    isDeleted: false,
    updateTimestamp: 1732075086619
  },
  {
    id: 846,
    skuId: 'J10817',
    title: 'COCO CRUSH戒指',
    plpTitle: '["COCO CRUSH", "戒指"]',
    pdpTitle: '["COCO CRUSH", "戒指"]',
    description: '菱格纹图案，标准款，米色18K金',
    plpDescription: '菱格纹图案，标准款\n米色18K金',
    pdpDescription: '菱格纹图案，标准款，米色18K金',
    price: 24100.0,
    localPrice: 0.0,
    isShow: '1',
    isPutOn: '1',
    plpTitleLine: 2,
    plpTitleType: 1,
    plpDescriptionLine: 2,
    pdpImgCount: 4,
    shareTitle: '虚拟试戴COCO CRUSH戒指',
    vtoType: 'RING',
    extJson:
      '{"navigationbackpath":"/activities/2025/cococrush/pages/index/index?scene=plp"}',
    view3d: 1,
    createTimestamp: 1715075135136,
    isDeleted: false,
    updateTimestamp: 1732075086060
  },
  {
    id: 847,
    skuId: 'J12304',
    title: 'COCO手链',
    plpTitle: '["COCO", "手链"]',
    pdpTitle: '["COCO", "手链"]',
    description: '菱格纹图案，白18K金，镶嵌钻石',
    plpDescription: '菱格纹图案，白18K金\n镶嵌钻石',
    pdpDescription: '菱格纹图案，白18K金，镶嵌钻石',
    price: 20000.0,
    localPrice: 0.0,
    isShow: '1',
    isPutOn: '0',
    plpTitleLine: 2,
    plpTitleType: 1,
    plpDescriptionLine: 2,
    pdpImgCount: 2,
    shareTitle: 'COCO手链',
    vtoType: '',
    extJson:
      '{"navigationbackpath":"/activities/2025/cococrush/pages/index/index?scene=plp"}',
    view3d: 1,
    createTimestamp: 1715075133697,
    isDeleted: false,
    updateTimestamp: 1732075085575
  },
  {
    id: 848,
    skuId: 'J12303',
    title: 'COCO手链',
    plpTitle: '["COCO", "手链"]',
    pdpTitle: '["COCO", "手链"]',
    description: '菱格纹图案，米色18K金',
    plpDescription: '菱格纹图案，米色18K金',
    pdpDescription: '菱格纹图案，米色18K金',
    price: 14500.0,
    localPrice: 0.0,
    isShow: '1',
    isPutOn: '0',
    plpTitleLine: 2,
    plpTitleType: 1,
    plpDescriptionLine: 1,
    pdpImgCount: 2,
    shareTitle: 'COCO手链',
    vtoType: '',
    extJson:
      '{"navigationbackpath":"/activities/2025/cococrush/pages/index/index?scene=plp"}',
    view3d: 1,
    createTimestamp: 1715075132523,
    isDeleted: false,
    updateTimestamp: 1732075085134
  },
  {
    id: 849,
    skuId: 'J12306',
    title: 'Coco Crush项链',
    plpTitle: '["COCO CRUSH", "项链"]',
    pdpTitle: '["COCO CRUSH", "项链"]',
    description: '菱格纹图案，米色18K金',
    plpDescription: '菱格纹图案，米色18K金',
    pdpDescription: '菱格纹图案，米色18K金',
    price: 21600.0,
    localPrice: 0.0,
    isShow: '1',
    isPutOn: '0',
    plpTitleLine: 2,
    plpTitleType: 1,
    plpDescriptionLine: 1,
    pdpImgCount: 4,
    shareTitle: 'COCO CRUSH项链',
    vtoType: '',
    extJson:
      '{"navigationbackpath":"/activities/2025/cococrush/pages/index/index?scene=plp"}',
    view3d: 1,
    createTimestamp: 1715075131748,
    isDeleted: false,
    updateTimestamp: 1732075084573
  },
  {
    id: 850,
    skuId: 'J10570',
    title: 'COCO CRUSH戒指',
    plpTitle: '["COCO CRUSH", "戒指"]',
    pdpTitle: '["COCO CRUSH", "戒指"]',
    description: '菱格纹图案，标准款，白18K金',
    plpDescription: '菱格纹图案，标准款\n白18K金',
    pdpDescription: '菱格纹图案，标准款，白18K金',
    price: 24500.0,
    localPrice: 0.0,
    isShow: '1',
    isPutOn: '1',
    plpTitleLine: 2,
    plpTitleType: 1,
    plpDescriptionLine: 2,
    pdpImgCount: 4,
    shareTitle: '虚拟试戴COCO CRUSH戒指',
    vtoType: 'RING',
    extJson:
      '{"navigationbackpath":"/activities/2025/cococrush/pages/index/index?scene=plp"}',
    view3d: 0,
    createTimestamp: 1715075131010,
    isDeleted: false,
    updateTimestamp: 1732075084111
  },
  {
    id: 851,
    skuId: 'J11871',
    title: 'COCO CRUSH戒指',
    plpTitle: '["COCO CRUSH", "戒指"]',
    pdpTitle: '["COCO CRUSH", "戒指"]',
    description: '菱格纹图案，精致款，白18K金，镶嵌钻石',
    plpDescription: '菱格纹图案，精致款\n白18K金，镶嵌钻石',
    pdpDescription: '菱格纹图案，精致款，白18K金，镶嵌钻石',
    price: 36600.0,
    localPrice: 0.0,
    isShow: '1',
    isPutOn: '1',
    plpTitleLine: 2,
    plpTitleType: 1,
    plpDescriptionLine: 2,
    pdpImgCount: 4,
    shareTitle: '虚拟试戴COCO CRUSH戒指',
    vtoType: 'RING',
    extJson:
      '{"navigationbackpath":"/activities/2025/cococrush/pages/index/index?scene=plp"}',
    view3d: 1,
    createTimestamp: 1715075129918,
    isDeleted: false,
    updateTimestamp: 1732075083569
  },
  {
    id: 852,
    skuId: 'J11785',
    title: 'COCO CRUSH戒指',
    plpTitle: '["COCO CRUSH", "戒指"]',
    pdpTitle: '["COCO CRUSH", "戒指"]',
    description: '菱格纹图案，精致款，米色18K金',
    plpDescription: '菱格纹图案，精致款\n米色18K金',
    pdpDescription: '菱格纹图案，精致款，米色18K金',
    price: 13300.0,
    localPrice: 0.0,
    isShow: '1',
    isPutOn: '1',
    plpTitleLine: 2,
    plpTitleType: 1,
    plpDescriptionLine: 2,
    pdpImgCount: 4,
    shareTitle: '虚拟试戴COCO CRUSH戒指',
    vtoType: 'RING',
    extJson:
      '{"navigationbackpath":"/activities/2025/cococrush/pages/index/index?scene=plp"}',
    view3d: 1,
    createTimestamp: 1715075129121,
    isDeleted: false,
    updateTimestamp: 1732075083062
  },
  {
    id: 853,
    skuId: 'J12327',
    title: 'COCO CRUSH手镯',
    plpTitle: '["COCO CRUSH", "手镯"]',
    pdpTitle: '["COCO CRUSH", "手镯"]',
    description: '菱格纹图案，精致款，黄18K金，镶嵌钻石',
    plpDescription: '菱格纹图案，精致款\n黄18K金，镶嵌钻石',
    pdpDescription: '菱格纹图案，精致款，黄18K金，镶嵌钻石',
    price: 75600.0,
    localPrice: 0.0,
    isShow: '1',
    isPutOn: '1',
    plpTitleLine: 2,
    plpTitleType: 1,
    plpDescriptionLine: 2,
    pdpImgCount: 3,
    shareTitle: '虚拟试戴COCO CRUSH手镯',
    vtoType: 'BRACELET',
    extJson:
      '{"navigationbackpath":"/activities/2025/cococrush/pages/index/index?scene=plp"}',
    view3d: 0,
    createTimestamp: 1715075128165,
    isDeleted: false,
    updateTimestamp: 1732075082561
  },
  {
    id: 854,
    skuId: 'J12325',
    title: 'COCO CRUSH手镯',
    plpTitle: '["COCO CRUSH", "手镯"]',
    pdpTitle: '["COCO CRUSH", "手镯"]',
    description: '菱格纹图案，精致款，黄18K金',
    plpDescription: '菱格纹图案，精致款\n黄18K金',
    pdpDescription: '菱格纹图案，精致款，黄18K金',
    price: 40600.0,
    localPrice: 0.0,
    isShow: '1',
    isPutOn: '1',
    plpTitleLine: 2,
    plpTitleType: 1,
    plpDescriptionLine: 2,
    pdpImgCount: 3,
    shareTitle: '虚拟试戴COCO CRUSH手镯',
    vtoType: 'BRACELET',
    extJson:
      '{"navigationbackpath":"/activities/2025/cococrush/pages/index/index?scene=plp"}',
    view3d: 0,
    createTimestamp: 1715075127443,
    isDeleted: false,
    updateTimestamp: 1732075082115
  },
  {
    id: 855,
    skuId: 'J12618',
    title: 'COCO CRUSH单只耳环',
    plpTitle: '["COCO CRUSH", "单只耳环"]',
    pdpTitle: '["COCO CRUSH", "单只耳环"]',
    description: '菱格纹图案，白18K金',
    plpDescription: '菱格纹图案，白18K金',
    pdpDescription: '菱格纹图案，白18K金',
    price: 12000.0,
    localPrice: 0.0,
    isShow: '1',
    isPutOn: '0',
    plpTitleLine: 2,
    plpTitleType: 1,
    plpDescriptionLine: 1,
    pdpImgCount: 3,
    shareTitle: 'COCO CRUSH单只耳环',
    vtoType: '',
    extJson:
      '{"navigationbackpath":"/activities/2025/cococrush/pages/index/index?scene=plp"}',
    view3d: 0,
    createTimestamp: 1715075126690,
    isDeleted: false,
    updateTimestamp: 1732075081411
  },
  {
    id: 856,
    skuId: 'J12326',
    title: 'COCO CRUSH手镯',
    plpTitle: '["COCO CRUSH", "手镯"]',
    pdpTitle: '["COCO CRUSH", "手镯"]',
    description: '菱格纹图案，精致款，米色18K金，镶嵌钻石',
    plpDescription: '菱格纹图案，精致款\n米色18K金，镶嵌钻石',
    pdpDescription: '菱格纹图案，精致款，米色18K金，镶嵌钻石',
    price: 77200.0,
    localPrice: 0.0,
    isShow: '1',
    isPutOn: '1',
    plpTitleLine: 2,
    plpTitleType: 1,
    plpDescriptionLine: 2,
    pdpImgCount: 3,
    shareTitle: '虚拟试戴COCO CRUSH手镯',
    vtoType: 'BRACELET',
    extJson:
      '{"navigationbackpath":"/activities/2025/cococrush/pages/index/index?scene=plp"}',
    view3d: 0,
    createTimestamp: 1715075125968,
    isDeleted: false,
    updateTimestamp: 1732075080971
  },
  {
    id: 857,
    skuId: 'J12328',
    title: 'COCO CRUSH手镯',
    plpTitle: '["COCO CRUSH", "手镯"]',
    pdpTitle: '["COCO CRUSH", "手镯"]',
    description: '菱格纹图案，精致款，白18K金，镶嵌钻石',
    plpDescription: '菱格纹图案，精致款\n白18K金，镶嵌钻石',
    pdpDescription: '菱格纹图案，精致款，白18K金，镶嵌钻石',
    price: 80900.0,
    localPrice: 0.0,
    isShow: '1',
    isPutOn: '1',
    plpTitleLine: 2,
    plpTitleType: 1,
    plpDescriptionLine: 2,
    pdpImgCount: 3,
    shareTitle: '虚拟试戴COCO CRUSH手镯',
    vtoType: 'BRACELET',
    extJson:
      '{"navigationbackpath":"/activities/2025/cococrush/pages/index/index?scene=plp"}',
    view3d: 0,
    createTimestamp: 1715075124766,
    isDeleted: false,
    updateTimestamp: 1732075080509
  },
  {
    id: 858,
    skuId: 'J12621',
    title: 'COCO CRUSH手镯',
    plpTitle: '["COCO CRUSH", "手镯"]',
    pdpTitle: '["COCO CRUSH", "手镯"]',
    description: '菱格纹图案，精致款，白18K金',
    plpDescription: '菱格纹图案，精致款\n白18K金',
    pdpDescription: '菱格纹图案，精致款，白18K金',
    price: 43500.0,
    localPrice: 0.0,
    isShow: '1',
    isPutOn: '1',
    plpTitleLine: 2,
    plpTitleType: 1,
    plpDescriptionLine: 2,
    pdpImgCount: 3,
    shareTitle: '虚拟试戴COCO CRUSH手镯',
    vtoType: 'BRACELET',
    extJson:
      '{"navigationbackpath":"/activities/2025/cococrush/pages/index/index?scene=plp"}',
    view3d: 0,
    createTimestamp: 1715075123478,
    isDeleted: false,
    updateTimestamp: 1732075079949
  },
  {
    id: 859,
    skuId: 'J12809',
    title: 'COCO CRUSH手镯',
    plpTitle: '["COCO CRUSH", "手镯"]',
    pdpTitle: '["COCO CRUSH", "手镯"]',
    description: '菱格纹图案，精致款，白18K金，镶嵌钻石',
    plpDescription: '菱格纹图案，精致款\n白18K金，镶嵌钻石',
    pdpDescription: '菱格纹图案，精致款，白18K金，镶嵌钻石',
    price: 121900.0,
    localPrice: 0.0,
    isShow: '1',
    isPutOn: '1',
    plpTitleLine: 2,
    plpTitleType: 1,
    plpDescriptionLine: 2,
    pdpImgCount: 3,
    shareTitle: '虚拟试戴COCO CRUSH手镯',
    vtoType: 'BRACELET',
    extJson:
      '{"navigationbackpath":"/activities/2025/cococrush/pages/index/index?scene=plp"}',
    view3d: 0,
    createTimestamp: 1715075122505,
    isDeleted: false,
    updateTimestamp: 1732075079512
  },
  {
    id: 860,
    skuId: 'J12324',
    title: 'COCO CRUSH手镯',
    plpTitle: '["COCO CRUSH", "手镯"]',
    pdpTitle: '["COCO CRUSH", "手镯"]',
    description: '菱格纹图案，精致款，米色18K金',
    plpDescription: '菱格纹图案，精致款\n米色18K金',
    pdpDescription: '菱格纹图案，精致款，米色18K金',
    price: 41500.0,
    localPrice: 0.0,
    isShow: '1',
    isPutOn: '1',
    plpTitleLine: 2,
    plpTitleType: 1,
    plpDescriptionLine: 2,
    pdpImgCount: 3,
    shareTitle: '虚拟试戴COCO CRUSH手镯',
    vtoType: 'BRACELET',
    extJson:
      '{"navigationbackpath":"/activities/2025/cococrush/pages/index/index?scene=plp"}',
    view3d: 0,
    createTimestamp: 1715075121709,
    isDeleted: false,
    updateTimestamp: 1732075079036
  },
  {
    id: 861,
    skuId: 'H6951',
    title: 'Première Édition Originale腕表',
    plpTitle: '["Première Édition", "Originale", "腕表"]',
    pdpTitle: '["Première Édition", "Originale", "腕表"]',
    description: '黄18K金镀层（0.1微米）精钢和黑色皮革，黑色漆面表盘',
    plpDescription: '黄18K金镀层 (0.1微米) 精钢\n和黑色皮革，黑色漆面表盘',
    pdpDescription: '黄18K金镀层 (0.1微米) 精钢和黑色皮革\n黑色漆面表盘',
    price: 51600.0,
    localPrice: 0.0,
    isShow: '1',
    isPutOn: '1',
    plpTitleLine: 2,
    plpTitleType: 3,
    plpDescriptionLine: 2,
    pdpImgCount: 2,
    shareTitle: '虚拟试戴PREMIÈRE腕表',
    vtoType: 'WATCH',
    extJson:
      '{"navigationbackpath":"/activities/2024/premiere-sound/pages/index/index?scene=plp"}',
    view3d: 1,
    createTimestamp: 1715075119858,
    isDeleted: false,
    updateTimestamp: 1732075078579
  },
  {
    id: 862,
    skuId: 'H5698',
    title: 'J12腕表，33毫米',
    plpTitle: '["J12", "腕表", "33", "毫米"]',
    pdpTitle: '["J12", "腕表", "33", "毫米"]',
    description: '白色精密陶瓷和精钢',
    plpDescription: '白色精密陶瓷和精钢',
    pdpDescription: '白色精密陶瓷和精钢',
    price: 47100.0,
    localPrice: 0.0,
    isShow: '1',
    isPutOn: '0',
    plpTitleLine: 2,
    plpTitleType: 2,
    plpDescriptionLine: 1,
    pdpImgCount: 1,
    shareTitle: '虚拟试戴J12腕表',
    vtoType: '',
    extJson:
      '{"navigationbackpath":"/activities/2024/j12/pages/landing/landing?scene=plp"}',
    view3d: 1,
    createTimestamp: 1715075118967,
    isDeleted: false,
    updateTimestamp: 1732075078052
  },
  {
    id: 863,
    skuId: 'H5697',
    title: 'J12 CALIBER 12.1腕表，38毫米',
    plpTitle: '["J12 CALIBER 12.1", "腕表", "38", "毫米"]',
    pdpTitle: '["J12 CALIBER 12.1", "腕表", "38", "毫米"]',
    description: '黑色精密陶瓷和精钢',
    plpDescription: '黑色精密陶瓷和精钢',
    pdpDescription: '黑色精密陶瓷和精钢',
    price: 65000.0,
    localPrice: 0.0,
    isShow: '1',
    isPutOn: '1',
    plpTitleLine: 2,
    plpTitleType: 2,
    plpDescriptionLine: 1,
    pdpImgCount: 3,
    shareTitle: '虚拟试戴J12腕表',
    vtoType: 'WATCH',
    extJson:
      '{"navigationbackpath":"/activities/2024/j12/pages/landing/landing?scene=plp"}',
    view3d: 1,
    createTimestamp: 1715075118020,
    isDeleted: false,
    updateTimestamp: 1732075077547
  },
  {
    id: 864,
    skuId: 'H5696',
    title: 'J12 CALIBER 12.2腕表，33毫米',
    plpTitle: '["J12 CALIBER 12.2", "腕表", "33", "毫米"]',
    pdpTitle: '["J12 CALIBER 12.2", "腕表", "33", "毫米"]',
    description: '黑色精密陶瓷和精钢',
    plpDescription: '黑色精密陶瓷和精钢',
    pdpDescription: '黑色精密陶瓷和精钢',
    price: 62200.0,
    localPrice: 0.0,
    isShow: '1',
    isPutOn: '1',
    plpTitleLine: 2,
    plpTitleType: 2,
    plpDescriptionLine: 1,
    pdpImgCount: 2,
    shareTitle: '虚拟试戴J12腕表',
    vtoType: 'WATCH',
    extJson:
      '{"navigationbackpath":"/activities/2024/j12/pages/landing/landing?scene=plp"}',
    view3d: 1,
    createTimestamp: 1715075117127,
    isDeleted: false,
    updateTimestamp: 1732075077093
  },
  {
    id: 865,
    skuId: 'H9742',
    title: 'J12 CALIBER 12.2腕表，33毫米',
    plpTitle: '["J12 CALIBER 12.2", "腕表", "33", "毫米"]',
    pdpTitle: '["J12 CALIBER 12.2", "腕表", "33", "毫米"]',
    description: '黑色精密陶瓷和精钢，钻石时标',
    plpDescription: '黑色精密陶瓷和精钢\n钻石时标',
    pdpDescription: '黑色精密陶瓷和精钢，钻石时标',
    price: 76500.0,
    localPrice: 0.0,
    isShow: '1',
    isPutOn: '0',
    plpTitleLine: 2,
    plpTitleType: 2,
    plpDescriptionLine: 2,
    pdpImgCount: 2,
    shareTitle: '虚拟试戴J12腕表',
    vtoType: '',
    extJson:
      '{"navigationbackpath":"/activities/2024/j12/pages/landing/landing?scene=plp"}',
    view3d: 0,
    createTimestamp: 1715075116309,
    isDeleted: false,
    updateTimestamp: 1732075076577
  },
  {
    id: 866,
    skuId: 'H9741',
    title: 'J12 CALIBER 12.2腕表，33毫米',
    plpTitle: '["J12 CALIBER 12.2", "腕表", "33", "毫米"]',
    pdpTitle: '["J12 CALIBER 12.2", "腕表", "33", "毫米"]',
    description: '白色精密陶瓷和精钢，钻石时标',
    plpDescription: '白色精密陶瓷和精钢\n钻石时标',
    pdpDescription: '白色精密陶瓷和精钢，钻石时标',
    price: 76500.0,
    localPrice: 0.0,
    isShow: '1',
    isPutOn: '0',
    plpTitleLine: 2,
    plpTitleType: 2,
    plpDescriptionLine: 2,
    pdpImgCount: 2,
    shareTitle: '虚拟试戴J12腕表',
    vtoType: '',
    extJson:
      '{"navigationbackpath":"/activities/2024/j12/pages/landing/landing?scene=plp"}',
    view3d: 0,
    createTimestamp: 1715075115475,
    isDeleted: false,
    updateTimestamp: 1732075076126
  },
  {
    id: 867,
    skuId: 'H9541',
    title: 'J12 Caliber 12.1腕表，38毫米',
    plpTitle: '["J12 Caliber 12.1", "腕表", "38", "毫米"]',
    pdpTitle: '["J12 Caliber 12.1", "腕表", "38", "毫米"]',
    description: '黑色精密陶瓷和黄18K金',
    plpDescription: '黑色精密陶瓷和黄18K金',
    pdpDescription: '黑色精密陶瓷和黄18K金',
    price: 129200.0,
    localPrice: 0.0,
    isShow: '1',
    isPutOn: '0',
    plpTitleLine: 2,
    plpTitleType: 2,
    plpDescriptionLine: 1,
    pdpImgCount: 1,
    shareTitle: '虚拟试戴J12腕表',
    vtoType: '',
    extJson:
      '{"navigationbackpath":"/activities/2024/j12/pages/landing/landing?scene=plp"}',
    view3d: 1,
    createTimestamp: 1715075114723,
    isDeleted: false,
    updateTimestamp: 1732075075585
  },
  {
    id: 868,
    skuId: 'H9540',
    title: 'J12 Caliber 12.1腕表，38毫米',
    plpTitle: '["J12 Caliber 12.1", "腕表", "38", "毫米"]',
    pdpTitle: '["J12 Caliber 12.1", "腕表", "38", "毫米"]',
    description: '白色精密陶瓷和黄18K金',
    plpDescription: '白色精密陶瓷和黄18K金',
    pdpDescription: '白色精密陶瓷和黄18K金',
    price: 129200.0,
    localPrice: 0.0,
    isShow: '1',
    isPutOn: '0',
    plpTitleLine: 2,
    plpTitleType: 2,
    plpDescriptionLine: 1,
    pdpImgCount: 1,
    shareTitle: '虚拟试戴J12腕表',
    vtoType: '',
    extJson:
      '{"navigationbackpath":"/activities/2024/j12/pages/landing/landing?scene=plp"}',
    view3d: 1,
    createTimestamp: 1715075113453,
    isDeleted: false,
    updateTimestamp: 1732075074116
  },
  {
    id: 869,
    skuId: 'H7431',
    title: 'J12 BAGUETTE DIAMOND BEZEL CALIBER 12.1腕表，38毫米',
    plpTitle:
      '["J12 BAGUETTE","DIAMOND BEZEL","CALIBER 12.1","腕表","38","毫米"]',
    pdpTitle:
      '["J12 BAGUETTE DIAMOND BEZEL","CALIBER 12.1","腕表","38","毫米"]',
    description: '白色精密陶瓷和白18K金，表圈镶嵌钻石',
    plpDescription: '白色精密陶瓷和白18K金\n表圈镶嵌钻石',
    pdpDescription: '白色精密陶瓷和白18K金，表圈镶嵌钻石',
    price: 1108000.0,
    localPrice: 0.0,
    isShow: '1',
    isPutOn: '0',
    plpTitleLine: 4,
    plpTitleType: 5,
    plpDescriptionLine: 2,
    pdpImgCount: 2,
    shareTitle: '虚拟试戴J12腕表',
    vtoType: '',
    extJson:
      '{"navigationbackpath":"/activities/2024/j12/pages/landing/landing?scene=plp"}',
    view3d: 0,
    createTimestamp: 1715075110840,
    isDeleted: false,
    updateTimestamp: 1732075073508
  },
  {
    id: 870,
    skuId: 'H7430',
    title: 'J12 BAGUETTE DIAMOND BEZEL CALIBER 12.2腕表，33毫米',
    plpTitle:
      '["J12 BAGUETTE","DIAMOND BEZEL","CALIBER 12.2","腕表","33","毫米"]',
    pdpTitle:
      '["J12 BAGUETTE DIAMOND BEZEL","CALIBER 12.2","腕表","33","毫米"]',
    description: '白色精密陶瓷和白18K金，表圈镶嵌钻石',
    plpDescription: '白色精密陶瓷和白18K金\n表圈镶嵌钻石',
    pdpDescription: '白色精密陶瓷和白18K金，表圈镶嵌钻石',
    price: 851000.0,
    localPrice: 0.0,
    isShow: '1',
    isPutOn: '0',
    plpTitleLine: 4,
    plpTitleType: 5,
    plpDescriptionLine: 2,
    pdpImgCount: 2,
    shareTitle: '虚拟试戴J12腕表',
    vtoType: '',
    extJson:
      '{"navigationbackpath":"/activities/2024/j12/pages/landing/landing?scene=plp"}',
    view3d: 0,
    createTimestamp: 1715075109890,
    isDeleted: false,
    updateTimestamp: 1732075072941
  },
  {
    id: 871,
    skuId: 'H7381',
    title: 'J12 CALIBER 5钻石陀飞轮腕表，38毫米',
    plpTitle: '["J12 CALIBER 5", "", "钻石陀飞轮腕表", "38", "毫米"]',
    pdpTitle: '["J12 CALIBER 5", "钻石陀飞轮腕表", "38", "毫米"]',
    description: '黑色精密陶瓷，表圈镶嵌钻石，镂空表盘',
    plpDescription: '黑色精密陶瓷\n表圈镶嵌钻石，镂空表盘',
    pdpDescription: '黑色精密陶瓷，表圈镶嵌钻石，镂空表盘',
    price: 1665000.0,
    localPrice: 0.0,
    isShow: '2',
    isPutOn: '0',
    plpTitleLine: 3,
    plpTitleType: 4,
    plpDescriptionLine: 2,
    pdpImgCount: 2,
    shareTitle: '虚拟试戴J12腕表',
    vtoType: '',
    extJson:
      '{"navigationbackpath":"/activities/2024/j12/pages/landing/landing?scene=plp"}',
    view3d: 0,
    createTimestamp: 1715075109176,
    isDeleted: false,
    updateTimestamp: 1732075072505
  },
  {
    id: 872,
    skuId: 'H7189',
    title: 'J12 DIAMOND BEZEL CALIBER 12.1腕表，38毫米',
    plpTitle: '["J12 DIAMOND","BEZEL CALIBER","12.1","腕表","38","毫米"]',
    pdpTitle: '["J12 DIAMOND BEZEL", "CALIBER 12.1", "腕表", "38", "毫米"]',
    description: '白色精密陶瓷和精钢，表圈和时标镶嵌钻石',
    plpDescription: '白色精密陶瓷和精钢\n表圈和时标镶嵌钻石',
    pdpDescription: '白色精密陶瓷和精钢，表圈和时标镶嵌钻石',
    price: 158500.0,
    localPrice: 0.0,
    isShow: '1',
    isPutOn: '0',
    plpTitleLine: 4,
    plpTitleType: 5,
    plpDescriptionLine: 2,
    pdpImgCount: 1,
    shareTitle: '虚拟试戴J12腕表',
    vtoType: '',
    extJson:
      '{"navigationbackpath":"/activities/2024/j12/pages/landing/landing?scene=plp"}',
    view3d: 0,
    createTimestamp: 1715075108151,
    isDeleted: false,
    updateTimestamp: 1732075071889
  },
  {
    id: 873,
    skuId: 'H6526',
    title: 'J12 DIAMOND BEZEL CALIBER 12.1腕表，38毫米',
    plpTitle: '["J12 DIAMOND","BEZEL CALIBER","12.1","腕表","38","毫米"]',
    pdpTitle: '["J12 DIAMOND BEZEL", "CALIBER 12.1", "腕表", "38", "毫米"]',
    description: '黑色精密陶瓷和精钢，表圈镶嵌钻石',
    plpDescription: '黑色精密陶瓷和精钢\n表圈镶嵌钻石',
    pdpDescription: '黑色精密陶瓷和精钢，表圈镶嵌钻石',
    price: 158500.0,
    localPrice: 0.0,
    isShow: '1',
    isPutOn: '0',
    plpTitleLine: 4,
    plpTitleType: 5,
    plpDescriptionLine: 2,
    pdpImgCount: 1,
    shareTitle: '虚拟试戴J12腕表',
    vtoType: '',
    extJson:
      '{"navigationbackpath":"/activities/2024/j12/pages/landing/landing?scene=plp"}',
    view3d: 0,
    createTimestamp: 1715075107117,
    isDeleted: false,
    updateTimestamp: 1732075071429
  },
  {
    id: 874,
    skuId: 'H6515',
    title: 'J12 PARADOXE CALIBER 12.1腕表，38毫米',
    plpTitle: '["J12 PARADOXE", "CALIBER 12.1", "腕表", "38", "毫米"]',
    pdpTitle: '["J12 PARADOXE CALIBER 12.1", "腕表", "38", "毫米"]',
    description: '白色、黑色精密陶瓷和精钢',
    plpDescription: '白色、黑色精密陶瓷和精钢',
    pdpDescription: '白色、黑色精密陶瓷和精钢',
    price: 82100.0,
    localPrice: 0.0,
    isShow: '1',
    isPutOn: '0',
    plpTitleLine: 3,
    plpTitleType: 4,
    plpDescriptionLine: 1,
    pdpImgCount: 2,
    shareTitle: '虚拟试戴J12腕表',
    vtoType: '',
    extJson:
      '{"navigationbackpath":"/activities/2024/j12/pages/landing/landing?scene=plp"}',
    view3d: 0,
    createTimestamp: 1715075106337,
    isDeleted: false,
    updateTimestamp: 1732075070792
  },
  {
    id: 875,
    skuId: 'H6419',
    title: 'J12腕表，33毫米',
    plpTitle: '["J12", "腕表", "33", "毫米"]',
    pdpTitle: '["J12", "腕表", "33", "毫米"]',
    description: '黑色精密陶瓷和精钢，表圈和时标镶嵌钻石',
    plpDescription: '黑色精密陶瓷和精钢\n表圈和时标镶嵌钻石',
    pdpDescription: '黑色精密陶瓷和精钢，表圈和时标镶嵌钻石',
    price: 123500.0,
    localPrice: 0.0,
    isShow: '1',
    isPutOn: '0',
    plpTitleLine: 2,
    plpTitleType: 2,
    plpDescriptionLine: 2,
    pdpImgCount: 1,
    shareTitle: '虚拟试戴J12腕表',
    vtoType: '',
    extJson:
      '{"navigationbackpath":"/activities/2024/j12/pages/landing/landing?scene=plp"}',
    view3d: 0,
    createTimestamp: 1715075105098,
    isDeleted: false,
    updateTimestamp: 1732075070308
  },
  {
    id: 876,
    skuId: 'H6418',
    title: 'J12腕表，33毫米',
    plpTitle: '["J12", "腕表", "33", "毫米"]',
    pdpTitle: '["J12", "腕表", "33", "毫米"]',
    description: '白色精密陶瓷和精钢，表圈和时标镶嵌钻石',
    plpDescription: '白色精密陶瓷和精钢\n表圈和时标镶嵌钻石',
    pdpDescription: '白色精密陶瓷和精钢，表圈和时标镶嵌钻石',
    price: 123500.0,
    localPrice: 0.0,
    isShow: '1',
    isPutOn: '0',
    plpTitleLine: 2,
    plpTitleType: 2,
    plpDescriptionLine: 2,
    pdpImgCount: 1,
    shareTitle: '虚拟试戴J12腕表',
    vtoType: '',
    extJson:
      '{"navigationbackpath":"/activities/2024/j12/pages/landing/landing?scene=plp"}',
    view3d: 0,
    createTimestamp: 1715075104355,
    isDeleted: false,
    updateTimestamp: 1732075069851
  },
  {
    id: 877,
    skuId: 'H6346',
    title: 'J12 PHANTOM腕表，33毫米',
    plpTitle: '["J12 PHANTOM", "腕表", "33", "毫米"]',
    pdpTitle: '["J12 PHANTOM", "腕表", "33", "毫米"]',
    description: '黑色精密陶瓷和精钢',
    plpDescription: '黑色精密陶瓷和精钢',
    pdpDescription: '黑色精密陶瓷和精钢',
    price: 52000.0,
    localPrice: 0.0,
    isShow: '1',
    isPutOn: '0',
    plpTitleLine: 2,
    plpTitleType: 2,
    plpDescriptionLine: 1,
    pdpImgCount: 2,
    shareTitle: '虚拟试戴J12腕表',
    vtoType: '',
    extJson:
      '{"navigationbackpath":"/activities/2024/j12/pages/landing/landing?scene=plp"}',
    view3d: 1,
    createTimestamp: 1715075103511,
    isDeleted: false,
    updateTimestamp: 1732075069407
  },
  {
    id: 878,
    skuId: 'H6345',
    title: 'J12 PHANTOM腕表，33毫米',
    plpTitle: '["J12 PHANTOM", "腕表", "33", "毫米"]',
    pdpTitle: '["J12 PHANTOM", "腕表", "33", "毫米"]',
    description: '白色精密陶瓷和精钢',
    plpDescription: '白色精密陶瓷和精钢',
    pdpDescription: '白色精密陶瓷和精钢',
    price: 52000.0,
    localPrice: 0.0,
    isShow: '1',
    isPutOn: '0',
    plpTitleLine: 2,
    plpTitleType: 2,
    plpDescriptionLine: 1,
    pdpImgCount: 2,
    shareTitle: '虚拟试戴J12腕表',
    vtoType: '',
    extJson:
      '{"navigationbackpath":"/activities/2024/j12/pages/landing/landing?scene=plp"}',
    view3d: 1,
    createTimestamp: 1715075102767,
    isDeleted: false,
    updateTimestamp: 1732075068920
  },
  {
    id: 879,
    skuId: 'H6186',
    title: 'J12 PHANTOM CALIBER 12.1腕表，38毫米',
    plpTitle: '["J12 PHANTOM", "CALIBER 12.1", "腕表", "38", "毫米"]',
    pdpTitle: '["J12 PHANTOM CALIBER 12.1", "腕表", "38", "毫米"]',
    description: '白色精密陶瓷和精钢',
    plpDescription: '白色精密陶瓷和精钢',
    pdpDescription: '白色精密陶瓷和精钢',
    price: 69900.0,
    localPrice: 0.0,
    isShow: '1',
    isPutOn: '0',
    plpTitleLine: 3,
    plpTitleType: 4,
    plpDescriptionLine: 1,
    pdpImgCount: 2,
    shareTitle: '虚拟试戴J12腕表',
    vtoType: '',
    extJson:
      '{"navigationbackpath":"/activities/2024/j12/pages/landing/landing?scene=plp"}',
    view3d: 1,
    createTimestamp: 1715075102040,
    isDeleted: false,
    updateTimestamp: 1732075068460
  },
  {
    id: 880,
    skuId: 'H6185',
    title: 'J12 PHANTOM CALIBER 12.1腕表，38毫米',
    plpTitle: '["J12 PHANTOM", "CALIBER 12.1", "腕表", "38", "毫米"]',
    pdpTitle: '["J12 PHANTOM CALIBER 12.1", "腕表", "38", "毫米"]',
    description: '黑色精密陶瓷和精钢',
    plpDescription: '黑色精密陶瓷和精钢',
    pdpDescription: '黑色精密陶瓷和精钢',
    price: 69900.0,
    localPrice: 0.0,
    isShow: '1',
    isPutOn: '0',
    plpTitleLine: 3,
    plpTitleType: 4,
    plpDescriptionLine: 1,
    pdpImgCount: 2,
    shareTitle: '虚拟试戴J12腕表',
    vtoType: '',
    extJson:
      '{"navigationbackpath":"/activities/2024/j12/pages/landing/landing?scene=plp"}',
    view3d: 1,
    createTimestamp: 1715075100718,
    isDeleted: false,
    updateTimestamp: 1732075068018
  },
  {
    id: 881,
    skuId: 'H5705',
    title: 'J12 CALIBER 12.1腕表，38毫米',
    plpTitle: '["J12 CALIBER 12.1", "腕表", "38", "毫米"]',
    pdpTitle: '["J12 CALIBER 12.1", "腕表", "38", "毫米"]',
    description: '白色精密陶瓷和精钢，钻石时标',
    plpDescription: '白色精密陶瓷和精钢\n钻石时标',
    pdpDescription: '白色精密陶瓷和精钢，钻石时标',
    price: 79200.0,
    localPrice: 0.0,
    isShow: '1',
    isPutOn: '1',
    plpTitleLine: 2,
    plpTitleType: 2,
    plpDescriptionLine: 2,
    pdpImgCount: 2,
    shareTitle: '虚拟试戴J12腕表',
    vtoType: 'WATCH',
    extJson:
      '{"navigationbackpath":"/activities/2024/j12/pages/landing/landing?scene=plp"}',
    view3d: 1,
    createTimestamp: 1715075099789,
    isDeleted: false,
    updateTimestamp: 1732075067519
  },
  {
    id: 882,
    skuId: 'H5704',
    title: 'J12腕表，33毫米',
    plpTitle: '["J12", "腕表", "33", "毫米"]',
    pdpTitle: '["J12", "腕表", "33", "毫米"]',
    description: '白色精密陶瓷和精钢，钻石时标，白色珍珠母贝表盘',
    plpDescription: '白色精密陶瓷和精钢\n钻石时标，白色珍珠母贝表盘',
    pdpDescription: '白色精密陶瓷和精钢，钻石时标，白色珍珠母贝表盘',
    price: 61500.0,
    localPrice: 0.0,
    isShow: '1',
    isPutOn: '0',
    plpTitleLine: 2,
    plpTitleType: 2,
    plpDescriptionLine: 2,
    pdpImgCount: 1,
    shareTitle: '虚拟试戴J12腕表',
    vtoType: '',
    extJson:
      '{"navigationbackpath":"/activities/2024/j12/pages/landing/landing?scene=plp"}',
    view3d: 1,
    createTimestamp: 1715075098867,
    isDeleted: false,
    updateTimestamp: 1732075067079
  },
  {
    id: 883,
    skuId: 'H5703',
    title: 'J12腕表，33毫米',
    plpTitle: '["J12", "腕表", "33", "毫米"]',
    pdpTitle: '["J12", "腕表", "33", "毫米"]',
    description: '白色精密陶瓷和精钢，钻石时标',
    plpDescription: '白色精密陶瓷和精钢\n钻石时标',
    pdpDescription: '白色精密陶瓷和精钢，钻石时标',
    price: 61500.0,
    localPrice: 0.0,
    isShow: '1',
    isPutOn: '1',
    plpTitleLine: 2,
    plpTitleType: 2,
    plpDescriptionLine: 2,
    pdpImgCount: 1,
    shareTitle: '虚拟试戴J12腕表',
    vtoType: 'WATCH',
    extJson:
      '{"navigationbackpath":"/activities/2024/j12/pages/landing/landing?scene=plp"}',
    view3d: 1,
    createTimestamp: 1715075097959,
    isDeleted: false,
    updateTimestamp: 1732075066627
  },
  {
    id: 884,
    skuId: 'H5702',
    title: 'J12 CALIBER 12.1腕表，38毫米',
    plpTitle: '["J12 CALIBER 12.1", "腕表", "38", "毫米"]',
    pdpTitle: '["J12 CALIBER 12.1", "腕表", "38", "毫米"]',
    description: '黑色精密陶瓷和精钢，钻石时标',
    plpDescription: '黑色精密陶瓷和精钢\n钻石时标',
    pdpDescription: '黑色精密陶瓷和精钢，钻石时标',
    price: 79200.0,
    localPrice: 0.0,
    isShow: '1',
    isPutOn: '1',
    plpTitleLine: 2,
    plpTitleType: 2,
    plpDescriptionLine: 2,
    pdpImgCount: 3,
    shareTitle: '虚拟试戴J12腕表',
    vtoType: 'WATCH',
    extJson:
      '{"navigationbackpath":"/activities/2024/j12/pages/landing/landing?scene=plp"}',
    view3d: 1,
    createTimestamp: 1715075096589,
    isDeleted: false,
    updateTimestamp: 1732075065857
  },
  {
    id: 885,
    skuId: 'H5701',
    title: 'J12腕表，33毫米',
    plpTitle: '["J12", "腕表", "33", "毫米"]',
    pdpTitle: '["J12", "腕表", "33", "毫米"]',
    description: '黑色精密陶瓷和精钢，钻石时标',
    plpDescription: '黑色精密陶瓷和精钢\n钻石时标',
    pdpDescription: '黑色精密陶瓷和精钢，钻石时标',
    price: 61500.0,
    localPrice: 0.0,
    isShow: '1',
    isPutOn: '1',
    plpTitleLine: 2,
    plpTitleType: 2,
    plpDescriptionLine: 2,
    pdpImgCount: 1,
    shareTitle: '虚拟试戴J12腕表',
    vtoType: 'WATCH',
    extJson:
      '{"navigationbackpath":"/activities/2024/j12/pages/landing/landing?scene=plp"}',
    view3d: 1,
    createTimestamp: 1715075095845,
    isDeleted: false,
    updateTimestamp: 1732075065382
  },
  {
    id: 886,
    skuId: 'H5700',
    title: 'J12 CALIBER 12.1腕表，38毫米',
    plpTitle: '["J12 CALIBER 12.1", "腕表", "38", "毫米"]',
    pdpTitle: '["J12 CALIBER 12.1", "腕表", "38", "毫米"]',
    description: '白色精密陶瓷和精钢',
    plpDescription: '白色精密陶瓷和精钢',
    pdpDescription: '白色精密陶瓷和精钢',
    price: 65000.0,
    localPrice: 0.0,
    isShow: '1',
    isPutOn: '1',
    plpTitleLine: 2,
    plpTitleType: 2,
    plpDescriptionLine: 1,
    pdpImgCount: 3,
    shareTitle: '虚拟试戴J12腕表',
    vtoType: 'WATCH',
    extJson:
      '{"navigationbackpath":"/activities/2024/j12/pages/landing/landing?scene=plp"}',
    view3d: 1,
    createTimestamp: 1715075095072,
    isDeleted: false,
    updateTimestamp: 1732075064907
  },
  {
    id: 887,
    skuId: 'H5699',
    title: 'J12 CALIBER 12.2腕表，33毫米',
    plpTitle: '["J12 CALIBER 12.2", "腕表", "33", "毫米"]',
    pdpTitle: '["J12 CALIBER 12.2", "腕表", "33", "毫米"]',
    description: '白色精密陶瓷和精钢',
    plpDescription: '白色精密陶瓷和精钢',
    pdpDescription: '白色精密陶瓷和精钢',
    price: 62200.0,
    localPrice: 0.0,
    isShow: '1',
    isPutOn: '1',
    plpTitleLine: 2,
    plpTitleType: 2,
    plpDescriptionLine: 1,
    pdpImgCount: 2,
    shareTitle: '虚拟试戴J12腕表',
    vtoType: 'WATCH',
    extJson:
      '{"navigationbackpath":"/activities/2024/j12/pages/landing/landing?scene=plp"}',
    view3d: 1,
    createTimestamp: 1715075093919,
    isDeleted: false,
    updateTimestamp: 1732075064420
  },
  {
    id: 888,
    skuId: 'H5695',
    title: 'J12腕表，33毫米',
    plpTitle: '["J12", "腕表", "33", "毫米"]',
    pdpTitle: '["J12", "腕表", "33", "毫米"]',
    description: '黑色精密陶瓷和精钢',
    plpDescription: '黑色精密陶瓷和精钢',
    pdpDescription: '黑色精密陶瓷和精钢',
    price: 47100.0,
    localPrice: 0.0,
    isShow: '1',
    isPutOn: '0',
    plpTitleLine: 2,
    plpTitleType: 2,
    plpDescriptionLine: 1,
    pdpImgCount: 1,
    shareTitle: '虚拟试戴J12腕表',
    vtoType: '',
    extJson:
      '{"navigationbackpath":"/activities/2024/j12/pages/landing/landing?scene=plp"}',
    view3d: 1,
    createTimestamp: 1715075092941,
    isDeleted: false,
    updateTimestamp: 1732075063982
  },
  {
    id: 889,
    skuId: 'H5238',
    title: 'J12·XS腕表，19毫米',
    plpTitle: '["J12·XS", "腕表", "19", "毫米"]',
    pdpTitle: '["J12·XS", "腕表", "19", "毫米"]',
    description: '白色精密陶瓷和精钢，内表圈和表链镶嵌明亮式切割钻石',
    plpDescription: '白色精密陶瓷和精钢\n内表圈和表链镶嵌\n明亮式切割钻石',
    pdpDescription: '白色精密陶瓷和精钢\n内表圈和表链镶嵌明亮式切割钻石',
    price: 121900.0,
    localPrice: 0.0,
    isShow: '1',
    isPutOn: '0',
    plpTitleLine: 2,
    plpTitleType: 2,
    plpDescriptionLine: 3,
    pdpImgCount: 1,
    shareTitle: '虚拟试戴J12腕表',
    vtoType: '',
    extJson:
      '{"navigationbackpath":"/activities/2024/j12/pages/landing/landing?scene=plp"}',
    view3d: 1,
    createTimestamp: 1715075092182,
    isDeleted: false,
    updateTimestamp: 1732075063491
  },
  {
    id: 890,
    skuId: 'H5237',
    title: 'J12·XS腕表，19毫米',
    plpTitle: '["J12·XS", "腕表", "19", "毫米"]',
    pdpTitle: '["J12·XS", "腕表", "19", "毫米"]',
    description: '白色精密陶瓷和精钢，内表圈镶嵌明亮式切割钻石',
    plpDescription: '白色精密陶瓷和精钢\n内表圈镶嵌明亮式切割钻石',
    pdpDescription: '白色精密陶瓷和精钢，内表圈镶嵌明亮式切割钻石',
    price: 67100.0,
    localPrice: 0.0,
    isShow: '1',
    isPutOn: '0',
    plpTitleLine: 2,
    plpTitleType: 2,
    plpDescriptionLine: 2,
    pdpImgCount: 2,
    shareTitle: '虚拟试戴J12腕表',
    vtoType: '',
    extJson:
      '{"navigationbackpath":"/activities/2024/j12/pages/landing/landing?scene=plp"}',
    view3d: 1,
    createTimestamp: 1715075090759,
    isDeleted: false,
    updateTimestamp: 1732075062948
  },
  {
    id: 891,
    skuId: 'H5236',
    title: 'J12·XS腕表，19毫米',
    plpTitle: '["J12·XS", "腕表", "19", "毫米"]',
    pdpTitle: '["J12·XS", "腕表", "19", "毫米"]',
    description: '黑色精密陶瓷和精钢，内表圈和表链镶嵌明亮式切割钻石',
    plpDescription: '黑色精密陶瓷和精钢\n内表圈和表链镶嵌\n明亮式切割钻石',
    pdpDescription: '黑色精密陶瓷和精钢\n内表圈和表链镶嵌明亮式切割钻石',
    price: 121900.0,
    localPrice: 0.0,
    isShow: '1',
    isPutOn: '0',
    plpTitleLine: 2,
    plpTitleType: 2,
    plpDescriptionLine: 3,
    pdpImgCount: 1,
    shareTitle: '虚拟试戴J12腕表',
    vtoType: '',
    extJson:
      '{"navigationbackpath":"/activities/2024/j12/pages/landing/landing?scene=plp"}',
    view3d: 1,
    createTimestamp: 1715075089381,
    isDeleted: false,
    updateTimestamp: 1732075062491
  },
  {
    id: 892,
    skuId: 'H5235',
    title: 'J12·XS腕表，19毫米',
    plpTitle: '["J12·XS", "腕表", "19", "毫米"]',
    pdpTitle: '["J12·XS", "腕表", "19", "毫米"]',
    description: '黑色精密陶瓷和精钢，内表圈镶嵌明亮式切割钻石',
    plpDescription: '黑色精密陶瓷和精钢\n内表圈镶嵌明亮式切割钻石',
    pdpDescription: '黑色精密陶瓷和精钢，内表圈镶嵌明亮式切割钻石',
    price: 67100.0,
    localPrice: 0.0,
    isShow: '1',
    isPutOn: '0',
    plpTitleLine: 2,
    plpTitleType: 2,
    plpDescriptionLine: 2,
    pdpImgCount: 2,
    shareTitle: '虚拟试戴J12腕表',
    vtoType: '',
    extJson:
      '{"navigationbackpath":"/activities/2024/j12/pages/landing/landing?scene=plp"}',
    view3d: 1,
    createTimestamp: 1715075088646,
    isDeleted: false,
    updateTimestamp: 1732075062022
  },
  {
    id: 893,
    skuId: 'H3101',
    title: 'J12 GMT腕表，41毫米',
    plpTitle: '["J12 GMT", "腕表", "41", "毫米"]',
    pdpTitle: '["J12 GMT", "腕表", "41", "毫米"]',
    description: '哑光黑色精密陶瓷和精钢',
    plpDescription: '哑光黑色精密陶瓷和精钢',
    pdpDescription: '哑光黑色精密陶瓷和精钢',
    price: 78800.0,
    localPrice: 0.0,
    isShow: '1',
    isPutOn: '0',
    plpTitleLine: 2,
    plpTitleType: 2,
    plpDescriptionLine: 1,
    pdpImgCount: 1,
    shareTitle: '虚拟试戴J12腕表',
    vtoType: '',
    extJson:
      '{"navigationbackpath":"/activities/2024/j12/pages/landing/landing?scene=plp"}',
    view3d: 1,
    createTimestamp: 1715075086731,
    isDeleted: false,
    updateTimestamp: 1732075061555
  },
  {
    id: 894,
    skuId: 'H2572',
    title: 'J12腕表，29毫米',
    plpTitle: '["J12", "腕表", "29", "毫米"]',
    pdpTitle: '["J12", "腕表", "29", "毫米"]',
    description: '白色精密陶瓷和精钢，表圈和时标镶嵌钻石，白色珍珠母贝表盘',
    plpDescription: '白色精密陶瓷和精钢\n表圈和时标镶嵌钻石\n白色珍珠母贝表盘',
    pdpDescription: '白色精密陶瓷和精钢，表圈和时标镶嵌钻石\n白色珍珠母贝表盘',
    price: 107800.0,
    localPrice: 0.0,
    isShow: '1',
    isPutOn: '0',
    plpTitleLine: 2,
    plpTitleType: 2,
    plpDescriptionLine: 3,
    pdpImgCount: 2,
    shareTitle: '虚拟试戴J12腕表',
    vtoType: '',
    extJson:
      '{"navigationbackpath":"/activities/2024/j12/pages/landing/landing?scene=plp"}',
    view3d: 1,
    createTimestamp: 1715075085393,
    isDeleted: false,
    updateTimestamp: 1732075061033
  },
  {
    id: 895,
    skuId: 'H2571',
    title: 'J12腕表，29毫米',
    plpTitle: '["J12", "腕表", "29", "毫米"]',
    pdpTitle: '["J12", "腕表", "29", "毫米"]',
    description: '黑色精密陶瓷和精钢，表圈和时标镶嵌钻石',
    plpDescription: '黑色精密陶瓷和精钢\n表圈和时标镶嵌钻石',
    pdpDescription: '黑色精密陶瓷和精钢，表圈和时标镶嵌钻石',
    price: 107800.0,
    localPrice: 0.0,
    isShow: '1',
    isPutOn: '0',
    plpTitleLine: 2,
    plpTitleType: 2,
    plpDescriptionLine: 2,
    pdpImgCount: 2,
    shareTitle: '虚拟试戴J12腕表',
    vtoType: '',
    extJson:
      '{"navigationbackpath":"/activities/2024/j12/pages/landing/landing?scene=plp"}',
    view3d: 1,
    createTimestamp: 1715075084477,
    isDeleted: false,
    updateTimestamp: 1732075060572
  },
  {
    id: 896,
    skuId: 'H2570',
    title: 'J12腕表，29毫米',
    plpTitle: '["J12", "腕表", "29", "毫米"]',
    pdpTitle: '["J12", "腕表", "29", "毫米"]',
    description: '白色精密陶瓷和精钢，钻石时标，白色珍珠母贝表盘',
    plpDescription: '白色精密陶瓷和精钢\n钻石时标，白色珍珠母贝表盘',
    pdpDescription: '白色精密陶瓷和精钢，钻石时标，白色珍珠母贝表盘',
    price: 57800.0,
    localPrice: 0.0,
    isShow: '1',
    isPutOn: '0',
    plpTitleLine: 2,
    plpTitleType: 2,
    plpDescriptionLine: 2,
    pdpImgCount: 2,
    shareTitle: '虚拟试戴J12腕表',
    vtoType: '',
    extJson:
      '{"navigationbackpath":"/activities/2024/j12/pages/landing/landing?scene=plp"}',
    view3d: 1,
    createTimestamp: 1715075083444,
    isDeleted: false,
    updateTimestamp: 1732075060017
  },
  {
    id: 897,
    skuId: 'H2569',
    title: 'J12腕表，29毫米',
    plpTitle: '["J12", "腕表", "29", "毫米"]',
    pdpTitle: '["J12", "腕表", "29", "毫米"]',
    description: '黑色精密陶瓷和精钢，钻石时标',
    plpDescription: '黑色精密陶瓷和精钢\n钻石时标',
    pdpDescription: '黑色精密陶瓷和精钢，钻石时标',
    price: 57800.0,
    localPrice: 0.0,
    isShow: '1',
    isPutOn: '0',
    plpTitleLine: 2,
    plpTitleType: 2,
    plpDescriptionLine: 2,
    pdpImgCount: 2,
    shareTitle: '虚拟试戴J12腕表',
    vtoType: '',
    extJson:
      '{"navigationbackpath":"/activities/2024/j12/pages/landing/landing?scene=plp"}',
    view3d: 1,
    createTimestamp: 1715075082196,
    isDeleted: false,
    updateTimestamp: 1732075059492
  },
  {
    id: 898,
    skuId: 'H2009',
    title: 'J12计时码表，41毫米',
    plpTitle: '["J12", "计时码表", "41", "毫米"]',
    pdpTitle: '["J12", "计时码表", "41", "毫米"]',
    description: '白色精密陶瓷和精钢，钻石时标',
    plpDescription: '白色精密陶瓷和精钢\n钻石时标',
    pdpDescription: '白色精密陶瓷和精钢，钻石时标',
    price: 106900.0,
    localPrice: 0.0,
    isShow: '1',
    isPutOn: '0',
    plpTitleLine: 2,
    plpTitleType: 2,
    plpDescriptionLine: 2,
    pdpImgCount: 1,
    shareTitle: '虚拟试戴J12腕表',
    vtoType: '',
    extJson:
      '{"navigationbackpath":"/activities/2024/j12/pages/landing/landing?scene=plp"}',
    view3d: 1,
    createTimestamp: 1715075081397,
    isDeleted: false,
    updateTimestamp: 1732075058912
  },
  {
    id: 899,
    skuId: 'H0940',
    title: 'J12计时码表，41毫米',
    plpTitle: '["J12", "计时码表", "41", "毫米"]',
    pdpTitle: '["J12", "计时码表", "41", "毫米"]',
    description: '黑色精密陶瓷和精钢',
    plpDescription: '黑色精密陶瓷和精钢',
    pdpDescription: '黑色精密陶瓷和精钢',
    price: 92600.0,
    localPrice: 0.0,
    isShow: '1',
    isPutOn: '0',
    plpTitleLine: 2,
    plpTitleType: 2,
    plpDescriptionLine: 1,
    pdpImgCount: 1,
    shareTitle: '虚拟试戴J12腕表',
    vtoType: '',
    extJson:
      '{"navigationbackpath":"/activities/2024/j12/pages/landing/landing?scene=plp"}',
    view3d: 1,
    createTimestamp: 1715075075843,
    isDeleted: false,
    updateTimestamp: 1732075058437
  }
]
